/**
* In Edit Hospital function is used to edit the hospital profile and it's functions declare this file
**/
import { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import * as Yup from 'yup';
import { validate, findDuplicateIndices, checkScheduleOverlap } from './../../../services/ValidationService';
import ApiService from './../../../services/ApiService';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { goBack, generateRandomId, convertTimeToDate, convert_DateToTime, convertS3privateToPublic, dataURItoBlob, filterGeoLocation, handleBookedAppointmentCheck, flatPickerFormatDate } from './../../../services/UtilsService';
import ImageCroper from './../../../shared/modals/ImageCroper';
import { toast } from 'react-toastify';
import TimezoneSelect from 'react-timezone-select';
import { DatePicker } from 'rsuite';
import Autocomplete from 'react-google-autocomplete';
import Select from 'react-select';
import moment from 'moment';
import AllAppointmentsCancelModal from '../../../shared/modals/AllAppointmentsCancelModal';
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import { useTranslation } from 'react-i18next';

function EditHospital() {
	//Intial variable declaration	
	let { id } = useParams();
	const [data, setData] = useState({});
	const [error, setError] = useState({});
	const [users, setUser] = useState({});
	const [physicianInfo, setPhysicianInfo] = useState([{ hospital: id, physician: '', days: [], startTime: '', endTime: '', timeZone: '', consultingDuration: '', out_of_office: ['["",""]'] }]);
	const [errorPhysician, setPhysicianError] = useState({});
	const [sameTimeErr, setSameTimeErr] = useState({});
	const [parentInfo, setParentInfo] = useState([{ hospital: id, physician: '', parent: '' }]);
	const [errorParent, setParentError] = useState({});
	const [isValid, setValid] = useState(true);
	const [tab, setTab] = useState(0);
	const navigate = useNavigate();
	const [image, setImage] = useState('');
	const [show, SetShow] = useState(false);
	const [cropImge, setCropImage] = useState();
	const [dublicateInfo, setDublicateInfo] = useState([]);
	const [physicianIdMap, setPhysicianIdMap] = useState([]);
	const [modalVisible, setModalVisible] = useState(false);
	const [modalModule, setModalModule] = useState('');
	const [bookedAppointments, setBookedAppointments] = useState([]);
	const uniquePhysicians = new Set();
	const startflatpickrRef = useRef([]);
	const endflatpickrRef = useRef([]);
	// store original mobile to avoid unnecessary API calls when unchanged
	const originalMobileRef = useRef('');
	const [valueToRemove, setValueToRemove] = useState(null); // State to hold the value to remove
	const [indexValue, setIndexValue] = useState(null); // State to hold the value to remove
	const [rowIndexValue, setRowIndexValue] = useState(null); // State to hold the value to remove
	const { t } = useTranslation();

	// New state for system timezone
	const [systemTimeZone, setSystemTimeZone] = useState('--');

	// Set the system's timezone when the component mounts
	useEffect(() => {
		const systemTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
		setSystemTimeZone(systemTimeZone);

		// Initialize hospitalInfo with system timezone if empty
		setPhysicianInfo((prevInfo) => prevInfo.map(item => ({
			...item,
			timeZone: item.timeZone || systemTimeZone
		})));
	}, []);

	//callback function
	const handleClose = () => {
		SetShow(false);
		// Reset the file input value
		const fileInput = document.getElementById('file-6');
		if (fileInput) {
			fileInput.value = ""; // Clear the file input so the same file can be selected again
		}
	};
	const imageData = (data) => setCropImage(data)

	/** 
	* To handle the image change
	* @e - we get the event details from the input file select action
	**/
	const handleFile = async (e) => {
		e.preventDefault();
		const file = e.target.files[0];
		openCropModal(file);

	}

	/** 
	* To open the image crop modal
	* @file - we pass the image details in the base 64 bit format
	**/
	const openCropModal = async (file) => {

		if (file) {
			let ext = file.name.split('.').pop();
			let allowedExtensions = ['jpg', 'jpeg', 'png', 'JPEG'];
			if (!allowedExtensions.includes(ext)) {
				toast.error(t('error.fileFormat'));
				await SetShow(false);
				return;
			}
			if (file.size > 100 * 1024 * 1024) {
				toast.error(t('error.fileSize'));
				await SetShow(false);
				return;
			}
			const reader = new FileReader();
			reader.onload = () => { setImage(reader.result) };
			reader.readAsDataURL(file);
			await SetShow(true);
		} else {
			await SetShow(false);
		}
	}

	/** 
	* To handle event drag
	* @e - we get the event details from the drag over action
	**/
	const handleDrag = (e) => {
		e.preventDefault();
	}

	//validate patterns
	const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

	/** 
	* To handle event drop
	* @e - we get the event details from the drop over action
	**/
	const handleDrop = (e) => {
		e.preventDefault();
		const { files } = e.dataTransfer;
		openCropModal(files[0]);
	}

	//components initialize function and api handling
	useEffect(() => {
		(async () => {
			if (id) {
				var response = await ApiService.getOrganization(id);
				var userResponse = await ApiService.getUsersList({ list: ['physician', 'parent', 'physician_mapping'] });
				if (response.status === 200)
					//setData(response.data.hospitalInfo);
					setData(prevData => ({
						...prevData,  // Preserve previous state
						...response.data.hospitalInfo,  // Merge hospitalInfo
						...(response.data.adminInfo && {  // Merge adminInfo if it exists
							admin_first_name: response.data.adminInfo.admin_first_name,
							admin_last_name: response.data.adminInfo.admin_last_name,
							/* admin_gender: String(response.data.adminInfo.admin_gender), */
							admin_mobileNumberWithCode: response.data.adminInfo.mobileNumber,
							admin_email: response.data.adminInfo.email
						})
					}));

				// determine original mobile (include country code when available) from hospital info first, then admin as fallback
				let originalCombined = '';
				if (response.data?.hospitalInfo?.mobileNumberWithCode) {
					originalCombined = response.data.hospitalInfo.mobileNumberWithCode;
				} else if (response.data?.hospitalInfo?.countryCode && response.data?.hospitalInfo?.mobileNumber) {
					originalCombined = `${response.data.hospitalInfo.countryCode} ${response.data.hospitalInfo.mobileNumber}`;
				} else if (response.data?.adminInfo?.mobileNumber) {
					originalCombined = response.data.adminInfo.mobileNumber;
				}
				if (originalCombined) {
					originalMobileRef.current = String(originalCombined).replace(/[^0-9]/g, '');
				}
				if (response.data.adminInfo?.mobileNumber) {
					setData(prevData => ({
						...prevData,
						...(response.data.adminInfo && {
							admin_mobileNumber: response.data.adminInfo.mobileNumber.split(' ')[1] || '',
						})
					}));
				}
				// Transform physicianInfo to include visitingSchedules
				if (response.data.physicianInfo.length) {
					const groupedPhysicianInfo = response.data.physicianInfo.reduce((acc, physician) => {
						const existingPhysician = acc.find((p) => p.physician === physician.physician);

						const newSchedule = {
							days: physician.days || [],
							startTime: physician.startTime || '',
							endTime: physician.endTime || '',
						};

						if (existingPhysician) {
							existingPhysician.visitingSchedules.push(newSchedule);
						} else {
							acc.push({
								...physician,
								//out_of_office: ['["",""]'],
								out_of_office:physician.out_of_office || ['["",""]'] ,
								visitingSchedules: [newSchedule],
							});
						}

						return acc;
					}, []);

					setPhysicianInfo(groupedPhysicianInfo);

					// Create a physician-ID mapping for quick lookup
					const newPhysicianIdMap = groupedPhysicianInfo.map(({ physician, id }) => ({
						physician,
						id,
					}));
					setPhysicianIdMap(newPhysicianIdMap);

					// Set valid physician IDs for selectedPhysicianId
					const initialPhysicianIds = groupedPhysicianInfo.map((physician) => physician.physician).filter(Boolean);
					setSelectedPhysicianId(initialPhysicianIds);
				}
				if (response.data.parentInfo.length) {
					var { parentInfo } = response.data;
					var parentTab = parentInfo.map(({ parent }) => (parent !== null));
					if (!parentTab.includes(false)) {
						var validParentInfo = parentInfo.filter(({ parent, physician }) => parent !== null && physician !== null); // Filter the parentInfo array to include only objects where both parent and physician are not null
						setParentInfo(validParentInfo);
						console.log("parentInfo***************** : ",validParentInfo);
					}
					//else {
						// Allow null values: handle cases where parent or physician might be null
						setParentInfo(parentInfo);
						console.log("parentInfo---------------> : ",parentInfo);
					//}
				}
				if (userResponse.status === 200) {
					const physicians = userResponse.data.physician;
                    const mappings = userResponse.data.physician_mapping;
					const filteredPhysician = userResponse.data.physician.filter(
						(physician) => !physician.hospital || physician.hospital === id
					);
					 // Additional condition: Check mapping conditions
					 const validPhysiciansWithMapping = filteredPhysician.filter(physician => {
                        return mappings.some(physician_mapping => 
                            (id === physician_mapping.mapped_id || physician_mapping.mapped_id === null) &&
                            physician_mapping.physician_account === physician.account
                        );
                    });
					setUser((prevUser) => ({
						...prevUser,
						physician: validPhysiciansWithMapping,
						parent: userResponse.data.parent,
					}));
					console.log("users : ",users);
					console.log("Filtered Physicians:", validPhysiciansWithMapping);
				}
			}
		})();
	}, [id]);

	/** 
	* Validation schema for Hospital Fields
	* @name - required field and pass the hospital name
	* @website - required field and pass the hospital website
	* @email - required field and should be in correct hospital email format 
	* @mobileNumber - required field and pass the hospital mobileNumber
	* @city - required field and pass the hospital city 
	* @state - required field and pass the hospital state
	* @zipcode - required field and pass the hospital zipcode
	**/
	const orgFields = [
		{ name: 'name', validation: Yup.string().required(t('error.required')) },
		{ name: 'website', validation: Yup.string().nullable()/* .required(t('error.required')) */ },
		{ 
		name: 'email', 
		validation: Yup.string()
			.email(t('error.email')) // built-in email validation
			.required(t('error.emailRequired')) 
		},
		{ name: 'mobileNumber', validation: Yup.string().required(t('error.required')) },
		{ name: 'city', validation: Yup.string().required(t('error.required')) },
		{ name: 'state', validation: Yup.string().required(t('error.required')) },
		{
		name: 'zipcode',
		validation: Yup.string()
			.required(t('error.required')) 
			.matches(/^[a-zA-Z0-9]+$/,t('error.zipcodeAlpha'))
		},
	];

	/** 
	* admin Validation schema 
	 * @admin_first_name - required field and pass the admin first_name
	 * @admin_last_name - required field and pass the admin last_name
	 * @admin_email - required field and should be in correct admin email format
	 * @admin_mobileNumber - required field and pass the admin mobileNumber
	 * @admin_gender - required field and pass the admin gender 
	**/
	const adminFields = [
		{ name: 'admin_first_name', validation: Yup.string().required(t('error.required')) },
		{ name: 'admin_last_name', validation: Yup.string().required(t('error.required')) },
		{ 
		name: 'admin_email', 
		validation: Yup.string()
			.test(t('error.emailInvalid'), t('error.emailInvalid'), (value) => { 
			return emailPattern.test(value); 
			})
			.required(t('error.emailRequired'))
		},
		/* { name: 'admin_mobileNumber', validation: Yup.string().required(t('error.required')) }, */
		/* { name: 'admin_gender', validation: Yup.string().required(t('error.required')) } */
	];


	/** 
	* Physician Validation schema 
	* @physician - required field and pass the selected physician name
	* @days - required field and pass the days in array format
	* @startTime - required field and pass the selected startTime value
	* @endTime - required field and pass the selected endTime value
	* @timeZone - required field and pass the selected timeZone value
	**/
	const phyFields = [
		{ name: 'physician', validation: Yup.string().required(t('error.required')) },
		{
			name: 'visitingSchedules',
			validation: Yup.array()
				.of(
					Yup.object().shape({
						days: Yup.array()
							.of(Yup.string())
							.min(1, t('common.selectAtleastOneDay'))
							.required(t('common.selectAtleastOneDay')),
						startTime: Yup.string().required(t('error.required')),
						endTime: Yup.string().required(t('error.required')),
					})
				)
				.min(1, "Add at least one schedule")
				.required("Visiting schedules are required"),
		},
		{ name: 'consultingDuration', validation: Yup.string().required(t('error.consultingDuration')) },
		// { name: 'startTime', validation: Yup.string().required(t('error.required')) },
		// { name: 'endTime', validation: Yup.string().required(t('error.required')) }
		//{ name: 'timeZone', validation: Yup.string().required(t('error.required')) }
	];

	/** Parent Validation schema
	* @physician - required field and pass the selected physician name
	* @parent - required field and pass the selected parent name
	**/
	const parentFields = [
		{ name: 'physician', validation: Yup.string().required(t('error.required')) },
		{ name: 'parent', validation: Yup.string().required(t('error.required')) }
	];


	/** To handle input change event 
	* @e - we get the event details from the Change action 
	**/
	const handleChange = async (e) => {
		const { name, value } = e.target;
		e.preventDefault();
		setData({ ...data, [name]: value });
		const Errors = await validate({ [name]: value }, orgFields);
		setError({ ...error, [name]: Errors[name] });
	};

	const processedPhysicianInfo = (physicianInfo) => {
		return physicianInfo.flatMap((item) => {
			// Ensure visitingSchedules exists and is an array
			const schedules = Array.isArray(item.visitingSchedules) ? item.visitingSchedules : [];
			//const newId = await generateRandomId();
			return schedules.map((schedule, index) => ({
				...item,
				id: index === 0 ? item.id : undefined, // Generate new IDs for duplicates
				days: schedule.days || [], // Fallback to an empty array if undefined
				startTime: schedule.startTime || '', // Fallback to an empty string if undefined
				endTime: schedule.endTime || '', // Fallback to an empty string if undefined
				visitingSchedules: [schedule], // Assign only the current schedule
				out_of_office: Array.isArray(item.out_of_office)
					? item.out_of_office.map((range) => {
						const formattedRange = range
							.replace(/"/g, '') // Remove double quotes
							.replace(/\[|]/g, '') // Remove brackets
							.split(',') // Split into array
							.join(','); // Rejoin without additional quotes

						// Add brackets back to wrap the string properly
						const finalRange = `[${formattedRange}]`;
						return finalRange;
					})
					: [], // Fallback to an empty array if out_of_office is undefined
			}));
		});
	};


	/** 
	* To handle all 3 tabs details form submit
	* @e - we get the event details from the form submit action
	**/
	const handleSubmit = async (e) => {
		e.preventDefault();
		var datas = {};
		// Filter out entries where the physician field is empty
		const validPhysicianInfo = physicianInfo.filter(item => item.physician !== '');
		var physicianTab = physicianInfo.map(({ hospital, ...remaining }) => Object.keys(remaining).find((key) => remaining[key] !== ''));
		var parentTab = parentInfo.map(({ hospital, ...remaining }) => Object.keys(remaining).find((key) => remaining[key] !== ''));

		// Validate the organization fields
		const tab1 = await validate(data, orgFields);
		if (Object.keys(tab1).length || !isValid) {
			setError(tab1);
			setTab(0);
			return;
		} else {
			datas.hospitalInfo = data;
		}

		// Validate the admin fields
		const tab2 = await validate(data, adminFields);
		if (Object.keys(tab2).length || !isValid) {
			setError(tab2);
			setTab(1);
			return;
		} else {
			datas.hospitalInfo = data;
		}

		// Process physician info
		let processedPhysicianInfoData = processedPhysicianInfo(validPhysicianInfo);

		// Generate unique IDs for duplicates
		const idTracker = new Map(); // Map to track IDs for each physician
		processedPhysicianInfoData = await Promise.all(
			processedPhysicianInfoData.map(async (item) => {
				if (!item.id) {
					if (!idTracker.has(item.physician)) {
						const newId = await generateRandomId();
						idTracker.set(item.physician, newId);
						return { ...item, id: newId };
					} else {
						return { ...item, id: idTracker.get(item.physician) };
					}
				}
				return item;
			})
		);

		for (let i = 0; i < processedPhysicianInfoData.length; i++) {
			const tab3 = await validate(processedPhysicianInfoData[i], phyFields);
			if (Object.keys(tab3).length) {
				setPhysicianError(tab3);
				setTab(2);
				return;
			}
		}

		//To check the physicianInfo tab error validation
		let Errors = {};
			const processedPhysicians = processedPhysicianInfo(physicianInfo);

			console.log("Processed physicians:", processedPhysicians);

			if (processedPhysicians.length === 0) {
				console.log("No physicians, adding the first physician...");
				addPhysicianInfo(0)(e); // Add physician if no records exist
				return; // Exit early to prevent moving to the next tab
			}

			// Validate all physicians
			const physicianErrors = await Promise.all(
				physicianInfo.map(async (physician, index) => {
					console.log(`Validating physician at index ${index}`);
					const validationErrors = await validate(physician, phyFields);
					console.log(`Validation errors for physician ${index}:`, validationErrors);

					// Only validate out_of_office if any field is filled
					const outOfOfficeErrors = physician.out_of_office.reduce((acc, row, dateIndex) => {
						try {
							const [startDate, endDate] = JSON.parse(preprocessRowString(row));

							// Only validate if any date field is filled
							if (startDate || endDate) {
								// Error if one date is filled but not the other
								if ((startDate && !endDate) || (!startDate && endDate)) {
									acc[`physicianInfo[${index}].out_of_office[${dateIndex}]`] =
										"Both start and end dates must be filled if one is started.";
								} else if (!startDate || !endDate) {
									acc[`physicianInfo[${index}].out_of_office[${dateIndex}]`] =
										t('common.bothStartAndEndDate');
								}else if (new Date(startDate) > new Date(endDate)) {
									acc[`physicianInfo[${index}].out_of_office[${dateIndex}]`] =
										t('common.startMustBeLessThan');
								} 
							} else {
								// No validation error if both dates are empty
								acc[`physicianInfo[${index}].out_of_office[${dateIndex}]`] = "";
							}

							// Check if dateIndex is greater than 0 (for rows after the first one)
							if (dateIndex > 0) {
								const [startDate, endDate] = JSON.parse(preprocessRowString(row));

								// Check if both start and end dates are filled
								if (!startDate || !endDate) {
									acc[`physicianInfo[${index}].out_of_office[${dateIndex}]`] =
										t('common.bothStartAndEndDate');
								}
							}
						} catch (error) {
							console.error("Error processing out_of_office row:", row, error);
							acc[`physicianInfo[${index}].out_of_office[${dateIndex}]`] =
								"Invalid date format. Please fix.";
						}
						return acc;
					}, {});

					return { index, validationErrors, outOfOfficeErrors };
				})
			);

			console.log("Physician errors:", physicianErrors);

			// Process and structure errors
			physicianErrors.forEach(({ index, validationErrors, outOfOfficeErrors }) => {
				// Flatten out_of_office errors
				Object.keys(outOfOfficeErrors).forEach((key) => {
					if (outOfOfficeErrors[key]) {  // Only include non-empty errors
						Errors[key] = outOfOfficeErrors[key];
						console.log(`Flattened out_of_office error: ${key} = ${outOfOfficeErrors[key]}`);
					}
				});

				// Keep other errors nested under `physicianInfo[index]`
				const nonOutOfOfficeErrors = Object.keys(validationErrors).reduce((acc, key) => {
					if (!key.startsWith(`physicianInfo[${index}].out_of_office`)) {
						acc[key] = validationErrors[key];
					}
					return acc;
				}, {});

				if (Object.keys(nonOutOfOfficeErrors).length > 0) {
					Errors[`physicianInfo[${index}]`] = {
						...Errors[`physicianInfo[${index}]`], // Preserve existing nested errors
						...nonOutOfOfficeErrors,
					};
				}

				// ADDITIONAL LOGIC: Extract `physician` and `consultingDuration` errors
				if (validationErrors.physician) {
					Errors.physician = validationErrors.physician;
				}
				if (validationErrors.consultingDuration) {
					Errors.consultingDuration = validationErrors.consultingDuration;
				}
			});

			console.log("All accumulated errors:", Errors);

			// Update the error state
			if (Object.keys(Errors).length > 0) {
				console.log("Setting physician errors:", Errors);
				setPhysicianError(Errors); // Set errors if there are any
				setTab(2);
				return; // Prevent moving to the next tab
			}

		// Process valid physicianInfo only if present
		if (validPhysicianInfo.length > 0 && !physicianTab.includes(undefined)) {
			datas.physicianInfo = processedPhysicianInfoData;
		}

		// Validate parent fields
		// Validate all rows in parentInfo
		let errors = {};
		for (let i = 0; i < parentInfo.length; i++) {
			const validationResult = await validate(parentInfo[i], parentFields);
			if (Object.keys(validationResult).length > 0) {
				errors[i] = validationResult; // Store errors for the row with index `i`
			}
		}

		// Include duplicate info errors if applicable
		if (dublicateInfo.length > 0) {
			dublicateInfo.forEach((index) => {
				errors[index] = {
					...errors[index],
					duplicate: "Already Exist", // Custom error message for duplicates
				};
			});
		}

		if (Object.keys(errors).length > 0) {
			setParentError(errors); // Set all row errors
			return;
		} else {
			datas.parentInfo = parentInfo; // No errors, proceed
			setParentError({}); // Clear previous errors
		}

		datas.hospitalInfo.id = id;
		datas.hospitalInfo.role = 4;
		datas.isUpdated = data.isUpdated;
		datas.email = datas.email || null;
		datas.website = datas.website || null;
		if (data.geo_location) {
			data.location = data.geo_location; // Assign the value of geo_location to location
			delete data.geo_location; // Remove the old geo_location property
		}
		var response = await ApiService.updateOrganization(datas);
		if (response.status === 200) {
			if (cropImge !== undefined) {
				const formData = new FormData();
				const fileConvertData = await dataURItoBlob(cropImge);
				formData.append('file', fileConvertData);
				await ApiService.uploadNewPhoto(id, formData);
			}
			navigate('/admin/hospital');
			toast.success(response?.data?.message);
		} else {
			toast.error(response?.data?.message || response?.data?.error?.message || 'Something went wrong');
		}
	};


	/** 
	* To change city input 
	* @e - we get the event details form the change action
	**/
	const changeCity = async (e) => {
		const { value } = e.target;
		var obj = {};
		if (value.trim().length === 0) {
			obj = { city: '', state: '' };
		} else {
			obj = { city: value };
		}
		setData((data) => ({ ...data, ...obj }));
		const Errors = await validate({ city: value }, orgFields);
		setError({ ...error, city: Errors['city'] });
	}

	/** 
	* To select city input 
	* @e - we get the event details from the Select action
	**/
	const selectCity = async (e) => {
		// Access address_one and address_two from the data object
		const addressOne = data.address_one || null;
		const addressTwo = data.address_two || null;
		var location = await filterGeoLocation(e, addressOne, addressTwo);
		await setData((data) => ({ ...data, ...location }));
	}

	/** To go to next page 
	* @tab - pass the selected tab value 
	* @e - we get the event details from the click action
	**/
	const goNext = (tab) => async (e) => {
		e.preventDefault();
		console.log("Tab:", tab); // Log current tab

		if (tab === 0) {
			console.log("Validating orgFields...");
			const Errors = await validate(data, orgFields);
			console.log("Errors from orgFields validation:", Errors);
			setError(Errors);
			if (!Object.keys(Errors).length && isValid) {
				console.log("No errors, moving to tab 1...");
				// Before moving to next tab, validate mobile uniqueness via API
				const ok = await checkHospitalMobile();
				if (ok) setTab(1);
			} else {
				console.log("Validation errors in orgFields:", Errors);
			}
		} else if (tab === 1) {
			console.log("Validating adminFields...");
			const Errors = await validate(data, adminFields);
			console.log("Errors from adminFields validation:", Errors);
			setError(Errors);
			if (!Object.keys(Errors).length && isValid) {
				console.log("No errors, moving to tab 2...");
				setTab(2); // Go to next tab
			} else {
				console.log("Validation errors in adminFields:", Errors);
			}
		} else if (tab === 2) {
			console.log("Validating physician info...");
			let Errors = {};
			const processedPhysicians = processedPhysicianInfo(physicianInfo);

			console.log("Processed physicians:", processedPhysicians);

			if (processedPhysicians.length === 0) {
				console.log("No physicians, adding the first physician...");
				addPhysicianInfo(0)(e); // Add physician if no records exist
				return; // Exit early to prevent moving to the next tab
			}

			// Validate all physicians
			const physicianErrors = await Promise.all(
				physicianInfo.map(async (physician, index) => {
					console.log(`Validating physician at index ${index}`);
					const validationErrors = await validate(physician, phyFields);
					console.log(`Validation errors for physician ${index}:`, validationErrors);

					// Only validate out_of_office if any field is filled
					const outOfOfficeErrors = physician.out_of_office.reduce((acc, row, dateIndex) => {
						try {
							const [startDate, endDate] = JSON.parse(preprocessRowString(row));

							// Only validate if any date field is filled
							if (startDate || endDate) {
								// Error if one date is filled but not the other
								if ((startDate && !endDate) || (!startDate && endDate)) {
									acc[`physicianInfo[${index}].out_of_office[${dateIndex}]`] =
										"Both start and end dates must be filled if one is started.";
								} else if (!startDate || !endDate) {
									acc[`physicianInfo[${index}].out_of_office[${dateIndex}]`] =
										t('common.bothStartAndEndDate');
								}else if (new Date(startDate) > new Date(endDate)) {
									acc[`physicianInfo[${index}].out_of_office[${dateIndex}]`] =
										t('common.startMustBeLessThan');
								} 
							} else {
								// No validation error if both dates are empty
								acc[`physicianInfo[${index}].out_of_office[${dateIndex}]`] = "";
							}

							// Check if dateIndex is greater than 0 (for rows after the first one)
							if (dateIndex > 0) {
								const [startDate, endDate] = JSON.parse(preprocessRowString(row));

								// Check if both start and end dates are filled
								if (!startDate || !endDate) {
									acc[`physicianInfo[${index}].out_of_office[${dateIndex}]`] =
									t('common.bothStartAndEndDate');
								}
							}
						} catch (error) {
							console.error("Error processing out_of_office row:", row, error);
							acc[`physicianInfo[${index}].out_of_office[${dateIndex}]`] =
								"Invalid date format. Please fix.";
						}
						return acc;
					}, {});

					return { index, validationErrors, outOfOfficeErrors };
				})
			);

			console.log("Physician errors:", physicianErrors);

			// Process and structure errors
			physicianErrors.forEach(({ index, validationErrors, outOfOfficeErrors }) => {
				// Flatten out_of_office errors
				Object.keys(outOfOfficeErrors).forEach((key) => {
					if (outOfOfficeErrors[key]) {  // Only include non-empty errors
						Errors[key] = outOfOfficeErrors[key];
						console.log(`Flattened out_of_office error: ${key} = ${outOfOfficeErrors[key]}`);
					}
				});

				// Keep other errors nested under `physicianInfo[index]`
				const nonOutOfOfficeErrors = Object.keys(validationErrors).reduce((acc, key) => {
					if (!key.startsWith(`physicianInfo[${index}].out_of_office`)) {
						acc[key] = validationErrors[key];
					}
					return acc;
				}, {});

				if (Object.keys(nonOutOfOfficeErrors).length > 0) {
					Errors[`physicianInfo[${index}]`] = {
						...Errors[`physicianInfo[${index}]`], // Preserve existing nested errors
						...nonOutOfOfficeErrors,
					};
				}

				// ADDITIONAL LOGIC: Extract `physician` and `consultingDuration` errors
				if (validationErrors.physician) {
					Errors.physician = validationErrors.physician;
				}
				if (validationErrors.consultingDuration) {
					Errors.consultingDuration = validationErrors.consultingDuration;
				}
			});

			console.log("All accumulated errors:", Errors);

			// Update the error state
			if (Object.keys(Errors).length > 0) {
				console.log("Setting physician errors:", Errors);
				setPhysicianError(Errors); // Set errors if there are any
				return; // Prevent moving to the next tab
			}

			console.log("No errors, proceeding to tab 3...");
			// If no errors, update state and proceed to the next tab
			setPhysicianInfo(processedPhysicians);
			setTab(3); // Go to next tab
		}
	};

		// Helper: call backend to check hospital mobile uniqueness
		const checkHospitalMobile = async () => {
			try {
				// Only call API if mobile number and country code are present
				if (!data?.mobileNumber || !data?.countryCode) return true;
				// Normalize current mobile including country code (digits only)
				const currentCombined = `${data.countryCode ? data.countryCode + ' ' : ''}${data.mobileNumber || ''}`;
				const currentNormalized = String(currentCombined).replace(/[^0-9]/g, '');
				// If original mobile exists and hasn't changed, skip API call
				if (originalMobileRef.current) {
					const orig = String(originalMobileRef.current);
					const curr = String(currentNormalized);
					// Treat as same if exact match or if one endsWith the other (handles country-code presence/absence)
					if (orig === curr || orig.endsWith(curr) || curr.endsWith(orig)) {
						return true; // unchanged, so treat as valid
					}
				}
				const payload = { mobileNumber: String(data.mobileNumber), countryCode: String(data.countryCode), id: id };
				const resp = await ApiService.checkHospitalMobileNumber(payload);
					if (resp && resp.status === 200) {
						return true;
					}
					// If API returns 409 with message, treat as taken
					if (resp && resp.status === 409) {
						const msg = resp.data?.message || 'This mobile number is already taken';
						toast.error(msg);
						setError(prev => ({ ...prev, mobileNumber: msg }));
						return false;
					}
					// Any other non-200 response - treat as failure to validate and prevent next
					const msg = resp?.data?.message || 'Error checking mobile number';
					toast.error(msg);
					setError(prev => ({ ...prev, mobileNumber: msg }));
					return false;
			} catch (err) {
				// If backend responds with 409, show toast and set field error
				const status = err?.response?.status;
				const msg = err?.response?.data?.message || t('common.error');
				if (status === 409) {
					toast.error(msg);
					setError(prev => ({ ...prev, mobileNumber: msg }));
					return false;
				}
				// On other errors, show generic toast but allow progression
					toast.error(err?.response?.data?.message || 'Error checking mobile number');
					return false;
			}
		};





	/** 
	* To check phone number valid or not 
	* @value - we pass the actual phone number
	* @country - we pass the countryCode
	* @e - we get the event details from the onChange action
	* @formattedValue - we pass the country formatted Value
	**/
	const handlePhone = async (value, country, e, formattedValue) => {
		const { dialCode } = country;
		const fieldName = e.target.name;

		// Check if the phone input is for admin_mobileNumber
		if (fieldName === 'admin_mobileNumber') {
			// Remove special characters except '+'
			const cleanedNumber = formattedValue?.replace(/[^0-9+]/g, '')?.replace('+' + dialCode, '');

			// Store as 'countryCode admin_mobileNumber'
			setData({
				...data,
				[fieldName]: `+${dialCode} ${cleanedNumber}`, // Storing the cleaned number with country code
				admin_mobileNumberWithCode: `+${dialCode} ${cleanedNumber}`,
			});

			// Validate admin_mobileNumber
			const Errors = await validate({ [fieldName]: cleanedNumber }, adminFields);
			setError({ ...error, [fieldName]: Errors[fieldName] });
		} else {
			// For regular mobileNumber
			setData({
				...data,
				countryCode: `+${dialCode}`,
				mobileNumberWithCode: formattedValue,
				[fieldName]: formattedValue.split("+" + dialCode + " ")[1],
				countryNameCode: country?.countryCode,
			});

			const Errors = await validate({ [fieldName]: formattedValue }, orgFields);
			setError({ ...error, [fieldName]: Errors[fieldName] });
		}

		// Check validity
		const { format } = country;
		if (format?.length === formattedValue?.length && (value.startsWith(dialCode) || dialCode.startsWith(value))) {
			setValid(true);
		} else {
			setValid(false);
		}
		if (e.target.name === 'admin_mobileNumber' && e.target.value.trim() === '') {
			setValid(true);
		}
	};

	const createSchema = (fields) => {
		const schema = {};
		fields.forEach((field) => {
			schema[field.name] = field.validation;
		});
		return Yup.object().shape(schema);
	};

	const validate = async (values, fields) => {
		const validationSchema = createSchema(fields);
		try {
			await validationSchema.validate(values, { abortEarly: false });
			return {}; // Return an empty object if no errors
		} catch (error) {
			const errors = {};
			if (error.inner) {
				error.inner.forEach((err) => {
					// Handle errors for visitingSchedules specifically
					if (err.path === "visitingSchedules") {
						// If visitingSchedules is empty, ensure all individual schedule errors are shown
						const scheduleErrors = (values.visitingSchedules || []).map((schedule, idx) => {
							const scheduleError = {};

							// Validate startTime, endTime, and days
							if (schedule.startTime === "") {
								scheduleError.startTime = "Field is required";
							}
							if (schedule.endTime === "") {
								scheduleError.endTime = "Field is required";
							}
							if (!Array.isArray(schedule.days) || schedule.days.length === 0) {
								scheduleError.days = t('common.selectAtleastOneDay');
							}

							// If the schedule is empty, set the error for both startTime and endTime
							if (!schedule.days || schedule.days.length === 0) {
								scheduleError.days = t('common.selectAtleastOneDay');
							}

							// Validate incorrect time order (start time > end time)
							else if (schedule.startTime && schedule.endTime && schedule.startTime > schedule.endTime) {
								scheduleError.startTime = t('error.incorrectTime');
							}

							// Validate same time issue (start time == end time)
							else if (schedule.startTime && schedule.endTime && schedule.startTime === schedule.endTime) {
								scheduleError.endTime = t('error.sameTime');
							}

							// Add individual schedule error to array
							return scheduleError;
						});

						// If no schedules exist, ensure the error structure is populated
						if (scheduleErrors.length === 0) {
							// If no visiting schedule errors, set a general error message
							errors.visitingSchedules = ["Visiting schedule is required"];
						} else {
							errors.visitingSchedules = scheduleErrors;
						}
					} else {
						// General error handling for other fields
						errors[err.path] = err.message;
					}
				});
			}
			return errors;
		}
	};




	/** 
	* To add physicianInfo
	* @index - we pass the index value of the UI select
	* @e - we get the event details from the click action
	**/
	const addPhysicianInfo = (index) => async (e) => {
		if (e) e.preventDefault(); // Guard against null event

		// Get the current hospital from the existing row
		const currentHospital = physicianInfo[index]?.hospital || '';
		const newRow = {
			hospital: currentHospital,
			days: [],
			startTime: '',
			endTime: '',
			visitingSchedules: [{
				days: [], // Ensure a default array
				startTime: '',
				endTime: '',
			}],
			timeZone: systemTimeZone,
			consultingDuration: '',
			out_of_office: ['[]'],
			isHospitalLocked: !!currentHospital, // Lock if pre-filled,
		};

		// Validate out_of_office field
		const currentOutOfOffice = physicianInfo[index]?.out_of_office || [];
		let hasErrors = false;

		const updatedErrors = currentOutOfOffice.reduce((errors, row, dateIndex) => {
			try {
				const [startDate, endDate] = JSON.parse(preprocessRowString(row));
				if ((startDate && !endDate) || (!startDate && endDate)) {
					errors[`physicianInfo[${index}].out_of_office[${dateIndex}]`] =
						"Both start and end dates must be filled if one is started.";
					hasErrors = true;
				} else {
					errors[`physicianInfo[${index}].out_of_office[${dateIndex}]`] = ""; // Clear error if valid
				}
			} catch (error) {
				console.error("Error processing out_of_office row:", row, error);
				errors[`physicianInfo[${index}].out_of_office[${dateIndex}]`] =
					"Invalid date format. Please fix.";
				hasErrors = true;
			}
			return errors;
		}, {});

		setPhysicianError((prev) => ({
			...prev,
			...updatedErrors,
		}));

		if (hasErrors) {
			return; // Prevent adding a new row if there are errors
		}
		// Check for schedule overlap
		if (checkScheduleOverlap(physicianInfo, newRow, index)) {
			setPhysicianError((prev) => ({
				...prev,
				[`physicianInfo[${index}].overlap`]: `${t('common.scheduleOverlap')}`,
			}));
			return;
		}

		// Clear overlap error if no conflict
		setPhysicianError((prev) => ({
			...prev,
			[`physicianInfo[${index}].overlap`]: "",
		}));

		const currentErrors = await validate(physicianInfo[index], phyFields);

		console.log("Full Current Errors Object:", currentErrors); // Logs the entire error object
		console.log("Stringified Errors:", JSON.stringify(currentErrors, null, 2)); // Pretty-printed JSON


		// Filter errors for visitingSchedules (specific to days, startTime, and endTime)
		const visitingScheduleErrors = Object.keys(currentErrors)
			.filter((key) => key.startsWith("visitingSchedules"))
			.reduce((acc, key) => {
				acc[key] = currentErrors[key]; // Preserve only visitingSchedules-related errors
				return acc;
			}, {});

		// Check for errors
		if (Object.keys(currentErrors).length > 0) {
			setPhysicianError((prev) => ({
				...prev,
				...(Object.keys(visitingScheduleErrors).length > 0 && {
					[`physicianInfo[${index}]`]: visitingScheduleErrors, // Nest visitingSchedules errors under physicianInfo[index]
				}),
				...Object.keys(currentErrors)
					.filter((key) => !key.startsWith("visitingSchedules")) // Other errors remain at the top level
					.reduce((acc, key) => {
						acc[key] = currentErrors[key];
						return acc;
					}, {}),
			}));
			return;
		}



		// Append the new row to the physicianInfo state
		setPhysicianInfo((prevState) => {
			const updatedPhysicianInfo = [...prevState, newRow];

			// Call processedPhysicianInfo with the updated array
			const processedInfo = processedPhysicianInfo(updatedPhysicianInfo);
			console.log("Processed Physician Info after addition:", processedInfo);

			return updatedPhysicianInfo; // Maintain the state update
		});
		// Proceed only if no validation errors exist for the current row
		// if (Object.keys(currentErrors).length === 0) {

		// 	// Validate the newly added row and update errors
		// 	const newErrors = await validate(newRow, phyFields);
		// 	setPhysicianError((prev) => ({
		// 		...prev,
		// 		[`physicianInfo[${index + 1}]`]: newErrors,
		// 	}));
		// }
	};


	/** 
	* To remove physicianInfo
	* @index - we pass the index value of the UI select
	* @e - we get the event details from the click action
	**/
	const removePhysicianInfo = (index) => async (e) => {
		const physician = physicianInfo[index].physician;
		const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
		const startTime = '00:00';
		const endTime = '24:00';
		const outofoffice = [];
		const timeZoneValue = physicianInfo[index].timeZone;
		// Call the function to handle API request and modal trigger
		const isBooked = await handleBookedAppointmentCheck(physician, days, startTime, endTime, outofoffice, (appointments) => {
			setBookedAppointments(appointments);
			setModalModule('schedule');
			setValueToRemove(physicianInfo[index]);
			setModalVisible(true);  // Show the modal with booked appointments
		}, timeZoneValue);
		// If the appointment is booked, don't continue with the rest of the logic
		if (isBooked) {
			return;
		}
		if (physicianInfo.length !== 1) {
			// Create a new array without the removed physician
			const updatedPhysicianInfo = physicianInfo.filter((_, idx) => idx !== index);

			// Update the selectedPhysicianId to exclude the removed physician
			const updatedSelectedPhysicianId = selectedPhysicianId.filter(
				(_, idx) => idx !== index
			);

			// Update the states
			setPhysicianInfo([...updatedPhysicianInfo]);
			setSelectedPhysicianId(updatedSelectedPhysicianId);
			filterPhysician([...updatedPhysicianInfo]); // Assuming this is dependent on physicianInfo
		} else {
			// Reset to a minimal structure if only one entry remains
			const resetRow = {
				hospital: id,
				physician: '',
				days: [],
				startTime: '',
				endTime: '',
				timeZone: '',
				consultingDuration: '',
				out_of_office: ['[]'],
			};

			setPhysicianInfo([resetRow]);
			setSelectedPhysicianId([]); // Reset selected IDs as well
			filterPhysician([resetRow]);
		}

		// Clear any error messages
		setPhysicianError({});
	};


	/** 
	* To handle the physicianInfo change
	* @index - we pass the index value of the UI select
	* @e - we get the event details form the change action
	**/
	const changePhysicianInfo = (index) => async (e) => {
		const { name, value, type, checked } = e.target;

		const updateArr = physicianInfo.map((item, i) => {
			if (index === i) {
				if (type === "checkbox" && name === "DaysOptions") {
					// Update days array based on checkbox selection
					const updatedDays = checked
						? [...item.days, value] // Add the selected day
						: item.days.filter((day) => day !== value); // Remove the deselected day
					return { ...item, days: updatedDays };
				}
				return { ...item, [name]: value }; // Update other fields
			}
			return item;
		});

		// Check for schedule overlap after updating the schedule
		const newSchedule = updateArr[index];
		// Validate for overlaps (exclude the current row index to avoid self-checking)
		if (checkScheduleOverlap(physicianInfo, newSchedule, index)) {
			setPhysicianError(prev => ({
				...prev,
				[`physicianInfo[${index}].overlap`]: `${t('common.scheduleOverlap')}`,
			}));
			return;  // Return early if there's an overlap
		}
		// Clear the overlap error if there is no conflict
		setPhysicianError(prev => ({
			...prev,
			[`physicianInfo[${index}].overlap`]: "",
		}));

		// Update the physicianInfo state
		setPhysicianInfo(updateArr);

		// Validate the updated physicianInfo entry
		const updatedPhysician = updateArr[index];
		const validationErrors = await validate(updatedPhysician, phyFields);

		// Update the error state, clearing the error for "days" if validation succeeds
		setPhysicianError((prevErrors) => ({
			...prevErrors,
			physician: validationErrors.physician || "",
			consultingDuration:"",
			days: validationErrors.days || "", // Clear the error if no validation error
			out_of_office: validationErrors.out_of_office || "", // Clear the error if no validation error
		}));
	};


	/** 
	* To handle changeTimeZone
	* @timezone - we pass the timezone value in utc format
	* @index - we pass the index number
	**/
	const changeTimeZone = async (timezone, index) => {
		const updateArr = physicianInfo.map((item, i) => {
			if (index === i) {
				return { ...item, timeZone: timezone.value };
			} else {
				return item;
			}
		});
		const Errors = await validate({ timeZone: timezone.value }, phyFields);
		setPhysicianError({ ...errorPhysician, timeZone: Errors['timeZone'] });
		setPhysicianInfo(updateArr);
	}

	/**
	* To set filtered physician list for parent tab
	* @a - we pass the remove physician details in array
	**/
	const filterPhysician = (a) => {
		var filterPhy = [...new Set(a.map(i => i.physician))];
		var filter = parentInfo.map((item) => {
			if (!filterPhy.includes(item.physician)) {
				return { ...item, physician: '' };
			} else {
				return item;
			}
		});
		setParentInfo(filter);

	};

	/** 
	* To add ParentInfo
	* @index - we pass the index value of the UI select
	* @e - we get the event details from the click action
	**/
	const addParentInfo = (index) => async (e) => {
		e.preventDefault();
		const Errors = await validate(parentInfo[index], parentFields);
		setParentError(Errors);
		if (Object.values(Errors).length === 0 && dublicateInfo.length === 0) {
			await setParentInfo(state => [...state, { hospital: id, physician: '', parent: '' }]);
			const Errors = await validate(parentInfo[index + 1], parentFields);
			await setParentError(Errors);
		}

	};

	/** 
	* To remove ParentInfo
	* @index - we pass the index value of the UI select
	* @e - we get the event details from the click action
	**/
	const removeParentInfo = (index) => async (e) => {
		e.preventDefault();
		if (parentInfo.length !== 1) {
			var removeArr = parentInfo.filter((i, idx) => idx !== index);
			await setParentInfo(removeArr);
			if ((await findDuplicateIndices(removeArr, 'parent', 'physician')).length > 0) {
				const duplicateIndices = await findDuplicateIndices(removeArr, 'parent', 'physician');
				duplicateIndices.shift();
				await setDublicateInfo(duplicateIndices);
			} else {
				await setDublicateInfo([]);
			}
		} else {
			setParentInfo([{ hospital: id, physician: '', parent: '' }]);
		};
		setParentError({});
	};

	/** 
	* To handle the parentInfo change
	* @index - we pass the index value of the UI select
	* @e - we get the event details form the change action
	**/
	const changeParentInfo = (index) => async (e) => {
		//e.preventDefault();
		const { name, value } = e.target;
		const updateArr = parentInfo.map((item, i) => {
			if (index === i) {
				return { ...item, [name]: value };
			} else {
				return item;
			}
		});
		const Errors = await validate({ [name]: value }, parentFields);
		// Remove the error if validation passes
		const updatedErrors = { ...errorParent };
		if (!Errors[name]) {
			delete updatedErrors[index]?.[name]; // Clear the error for the specific field
			if (Object.keys(updatedErrors[index] || {}).length === 0) {
				delete updatedErrors[index]; // Remove the entire row's error object if it's empty
			}
		} else {
			// Set the error for the field if validation fails
			updatedErrors[index] = {
				...updatedErrors[index],
				[name]: Errors[name],
			};
		}
	
		// Update the state with the new errors and parentInfo
		await setParentError(updatedErrors);
		await setParentInfo(updateArr);
	
		// Check for duplicates
		const duplicateIndices = await findDuplicateIndices(updateArr, 'parent', 'physician');
		await setDublicateInfo(duplicateIndices.length > 0 ? duplicateIndices.slice(1) : []);
	};

	// Function to preprocess row string
	const preprocessRowString = (row) => {
		if (typeof row === "string" && row.startsWith("[") && row.endsWith("]")) {
			// Check if the row matches the specific case of "[,]"
			if (row === "[,]") {
				return '["",""]'; // Replace with a valid JSON array of two empty strings
			}
			// Check if the row is already properly formatted (i.e., dates are already inside quotes)
			const isAlreadyFormatted = row.match(/"\d{4}-\d{2}-\d{2}"/g);

			// If it's already properly formatted, do nothing and return the row
			if (isAlreadyFormatted && isAlreadyFormatted.length === row.match(/\d{4}-\d{2}-\d{2}/g).length) {
				return row; // Return the row as-is if it's already properly formatted
			}
			// Add quotes around each date to make it valid JSON
			return row.replace(/(\d{4}-\d{2}-\d{2})/g, '"$1"');
		}

		return row; // Return as-is if it's not a stringified array
	};

	// Handle changes to date inputs (Start and End dates)
	const handleDateChange = async (physicianIndex, rowIndex, field, value) => {
		setIndexValue(physicianIndex);
		setRowIndexValue(rowIndex);
		let newOutOfOffice = []; // Initialize newOutOfOffice as an empty array
		// Extract the start and end dates from the current out_of_office value at the given index
		let currentDateRange = physicianInfo[physicianIndex].out_of_office[rowIndex];
		let dateArray = currentDateRange ? currentDateRange.replace(/[\[\]]/g, '').split(',') : [];
		// Handle the logic for modifying the startDate or endDate
		if (field === 'startDate') {
			// If startDate is being changed, update the start date and keep the existing end date
			newOutOfOffice.push(`[${flatPickerFormatDate(value)},${dateArray[1] || flatPickerFormatDate(value)}]`);
		} else if (field === 'endDate') {
			// If endDate is being changed, update the end date and keep the existing start date
			newOutOfOffice.push(`[${dateArray[0] || flatPickerFormatDate(value)},${flatPickerFormatDate(value)}]`);
		}
		const physician = physicianInfo[physicianIndex].physician;
		const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
		const startTime = '00:00';
		const endTime = '00:00';
		const outofoffice = newOutOfOffice;
		physicianInfo[physicianIndex].newOutOfOffice = newOutOfOffice;
		// Call the function to handle API request and modal trigger
		const isBooked = await handleBookedAppointmentCheck(physician, days, startTime, endTime, outofoffice, (appointments) => {
			setBookedAppointments(appointments);
			setModalModule('out_of_office_hospital');
			setModalVisible(true);  // Show the modal with booked appointments
		});
		// If the appointment is booked, don't continue with the rest of the logic
		if (isBooked) {
			return;
		}

		const updatedPhysicianInfo = physicianInfo.map((physician, idx) => {
			console.log("1");
			if (idx === physicianIndex) {
				console.log("2", physician);
				const updatedDateRows = physician.out_of_office.map((row, i) => {
					console.log("3");
					if (i === rowIndex) {
						let parsedRow = ["", ""]; // Default to empty dates
						try {
							const preprocessedRow = preprocessRowString(row); // Preprocess before parsing
							parsedRow = JSON.parse(preprocessedRow);
						} catch (e) {
							console.error("Error parsing row string:", row, e);
						}

						const [startDate, endDate] = parsedRow;

						// Update the start or end date based on the field being modified
						const newStartDate = field === "startDate" ? flatPickerFormatDate(value) : flatPickerFormatDate(startDate);
						const newEndDate =
							field === "endDate" && flatPickerFormatDate(value) ? flatPickerFormatDate(value) : field === "endDate" && !flatPickerFormatDate(value) ? null : flatPickerFormatDate(endDate);

						return JSON.stringify([newStartDate, newEndDate]);
					}
					return row; // No changes for other rows
				});

				// Revalidate all rows for overlaps and errors after update
				const errors = {}; // Temporary error object for revalidation
				updatedDateRows.forEach((currentRow, currentIndex) => {
					try {
						const [currentStart, currentEnd] = JSON.parse(preprocessRowString(currentRow) || "[]");
						const currentStartDate = currentStart ? new Date(currentStart) : null;
						const currentEndDate = currentEnd ? new Date(currentEnd) : null;

						// Validate Start Date <= End Date
						if (currentStartDate && currentEndDate && currentStartDate > currentEndDate) {
							if (currentIndex === rowIndex) {
								errors[`physicianInfo[${physicianIndex}].out_of_office[${currentIndex}]`] =
									t('common.startMustBeLessThan');
							}
						} else {
							// Check for overlapping date ranges with other rows
							const isOverlap = updatedDateRows.some((existingRow, i) => {
								if (i !== currentIndex) {
									const [existingStart, existingEnd] = JSON.parse(preprocessRowString(existingRow) || "[]");
									const existingStartDate = existingStart ? new Date(existingStart) : null;
									const existingEndDate = existingEnd ? new Date(existingEnd) : null;

									return (
										currentStartDate &&
										currentEndDate &&
										existingStartDate &&
										existingEndDate &&
										currentStartDate <= existingEndDate &&
										currentEndDate >= existingStartDate
									);
								}
								return false;
							});

							if (isOverlap && currentIndex === rowIndex) {
								// Show the error only for the current modified row
								errors[`physicianInfo[${physicianIndex}].out_of_office[${currentIndex}]`] =
									`${t('common.datesExist')}`;
							} else if (currentIndex === rowIndex) {
								// Clear the error for the current row if no overlap
								errors[`physicianInfo[${physicianIndex}].out_of_office[${currentIndex}]`] = "";
							}
						}
					} catch (e) {
						console.error("Error during revalidation of row:", currentRow, e);
					}
				});

				// Update the error state with the new validation results
				setPhysicianError((prev) => ({
					...prev,
					...errors,
				}));
				console.log("physicianErrors------------",errorPhysician);
				return { ...physician, out_of_office: updatedDateRows };
			}
			return physician;
		});

		setPhysicianInfo(updatedPhysicianInfo);
	};

	// Add new date row and check for duplicate date ranges
	const addDateRow = (physicianIndex) => {
		const updatedPhysicianInfo = physicianInfo.map((physician, idx) => {
			if (idx === physicianIndex) {
				const lastRowIndex = physician.out_of_office.length - 1;
				const lastRow = physician.out_of_office[lastRowIndex];
				let startDate, endDate;

				try {
					// Preprocess and parse the last row
					const preprocessedRow = preprocessRowString(lastRow);
					const parsedRow = JSON.parse(preprocessedRow);
					[startDate, endDate] = parsedRow;

					// Check if any error exists for the current row
					const currentRowError =
						errorPhysician[`physicianInfo[${physicianIndex}].out_of_office[${lastRowIndex}]`];
					if (currentRowError) {
						console.error("Cannot add a new row because of errors in the current row");
						return physician; // Prevent adding a new row if there's an error
					}

					// Validate that both start and end dates are filled
					if (!startDate || !endDate) {
						setPhysicianError((prev) => ({
							...prev,
							[`physicianInfo[${physicianIndex}].out_of_office[${lastRowIndex}]`]:
								t('common.bothStartAndEndDate'),
						}));
						return physician; // Stop and show the error
					}

					// Check for duplicate date ranges
					const isDuplicate = physician.out_of_office.some((row, rowIndex) => {
						if (rowIndex !== lastRowIndex) {
							let parsedRow;
							try {
								const preprocessedRow = preprocessRowString(row);
								parsedRow = JSON.parse(preprocessedRow);
								const [existingStartDate, existingEndDate] = parsedRow;
								return existingStartDate === startDate && existingEndDate === endDate;
							} catch (error) {
								console.error("Error parsing row for duplicate check:", row);
							}
						}
						return false;
					});

					if (isDuplicate) {
						// Set error for duplicate date
						setPhysicianError((prev) => ({
							...prev,
							[`physicianInfo[${physicianIndex}].out_of_office[${lastRowIndex}]`]:
								`${t('common.datesExist')}`,
						}));
						return physician; // Prevent adding a new row
					} else {
						// Clear errors for the current row if no duplicates
						setPhysicianError((prev) => ({
							...prev,
							[`physicianInfo[${physicianIndex}].out_of_office[${lastRowIndex}]`]: "",
						}));
					}
				} catch (error) {
					console.error("Error parsing the last row:", error);
				}

				// If no errors, add a new empty row
				const newDateRows = [...physician.out_of_office, JSON.stringify(["", ""])];
				return { ...physician, out_of_office: newDateRows };
			}
			return physician;
		});

		setPhysicianInfo(updatedPhysicianInfo);
	};


	// Remove date row (handles both removing and resetting)
	const removeDateRow = (physicianIndex, rowIndex) => {
	
		// Clean up refs for the removed row
		delete startflatpickrRef.current[`start-${physicianIndex}-${rowIndex}`];
		delete endflatpickrRef.current[`end-${physicianIndex}-${rowIndex}`];
		// Adjust other refs to match the new indices
		Object.keys(startflatpickrRef.current).forEach((key) => {
			const match = key.match(
				new RegExp(`start-${physicianIndex}-(\\d+)`)
			);
			if (match) {
				const currentRowIndex = parseInt(match[1], 10);
				if (currentRowIndex > rowIndex) {
					startflatpickrRef.current[
						`start-${physicianIndex}-${currentRowIndex - 1}`
					] = startflatpickrRef.current[key];
					delete startflatpickrRef.current[key];
				}
			}
		});

		Object.keys(endflatpickrRef.current).forEach((key) => {
			const match = key.match(
				new RegExp(`end-${physicianIndex}-(\\d+)`)
			);
			if (match) {
				const currentRowIndex = parseInt(match[1], 10);
				if (currentRowIndex > rowIndex) {
					endflatpickrRef.current[
						`end-${physicianIndex}-${currentRowIndex - 1}`
					] = endflatpickrRef.current[key];
					delete endflatpickrRef.current[key];
				}
			}
		});
		
		const updatedPhysicianInfo = physicianInfo.map((physician, idx) => {
			if (idx === physicianIndex) {
				let updatedDateRows = [...physician.out_of_office];

				if (updatedDateRows.length > 1) {
					// If there's more than one row, remove the row at the given index
					updatedDateRows = updatedDateRows.filter((_, i) => i !== rowIndex);
				} else if (updatedDateRows.length === 1) {
					// If there's only one row, reset its values to empty instead of deleting it
					updatedDateRows[0] = JSON.stringify(["", ""]);
				}

				return { ...physician, out_of_office: updatedDateRows };
			}
			return physician;
		});

		// Clear the errors for the removed row
		setPhysicianError((prev) => {
			const updatedErrors = { ...prev };
			delete updatedErrors[`physicianInfo[${physicianIndex}].out_of_office[${rowIndex}]`];

			// Re-index errors for remaining rows after deletion
			const reIndexedErrors = {};
			Object.keys(updatedErrors).forEach((key) => {
				const match = key.match(
					new RegExp(`physicianInfo\\[${physicianIndex}\\]\\.out_of_office\\[(\\d+)\\]`)
				);
				if (match) {
					const currentRow = parseInt(match[1], 10);
					if (currentRow > rowIndex) {
						// Shift error keys for rows after the deleted one
						const newKey = key.replace(
							`out_of_office[${currentRow}]`,
							`out_of_office[${currentRow - 1}]`
						);
						reIndexedErrors[newKey] = updatedErrors[key];
					} else if (currentRow < rowIndex) {
						// Keep error keys for unaffected rows
						reIndexedErrors[key] = updatedErrors[key];
					}
				} else {
					// Keep any other errors that don't belong to this physicianIndex
					reIndexedErrors[key] = updatedErrors[key];
				}
			});

			return reIndexedErrors;
		});

		setPhysicianInfo(updatedPhysicianInfo);
	};



	// Add Visiting Schedule 
	const addVisitingSchedule = (physicianIndex) => {
		setPhysicianInfo((prevPhysicianInfo) =>
			prevPhysicianInfo.map((physician, index) => {
				if (index === physicianIndex) {
					// Initialize visitingSchedules if it's undefined or null
					const schedules = physician.visitingSchedules || [];
					console.log("schedules : ", schedules);

					// If schedules are empty, use a default structure
					if (schedules.length === 0) {
						schedules.push({ days: [], startTime: "", endTime: "" });
					}
					console.log("schedules after default : ", schedules);

					// Get the last schedule safely
					const lastSchedule = schedules[schedules.length - 1] || {
						days: [],
						startTime: "",
						endTime: ""
					};
					console.log("lastSchedule : ", lastSchedule);

					// Safely check for field errors
					const hasErrors =
						!lastSchedule.days?.length ||
						!lastSchedule.startTime ||
						!lastSchedule.endTime ||
						(lastSchedule.startTime && lastSchedule.endTime && lastSchedule.startTime === lastSchedule.endTime) ||
						(lastSchedule.startTime && lastSchedule.endTime && lastSchedule.startTime > lastSchedule.endTime);

					// Check for overlap before proceeding
					const hasOverlap = checkScheduleOverlap(
						schedules,
						lastSchedule,
						schedules.length - 1
					);

					if (hasErrors || hasOverlap) {
						// If there are errors, set physicianError state
						setPhysicianError((prevErrors) => {
							const newErrors = { ...prevErrors };
							const scheduleIndex = schedules.length > 0 ? schedules.length - 1 : 0; // Condition to set scheduleIndex

							if (hasOverlap) {
								newErrors[`physicianInfo[${physicianIndex}].visitingSchedules[${scheduleIndex}].overlap`] = `${t('common.scheduleOverlap')}`;
							}
							if (!lastSchedule.days?.length) {
								newErrors[`physicianInfo[${physicianIndex}]`] = {
									...newErrors[`physicianInfo[${physicianIndex}]`],
									[`visitingSchedules[${scheduleIndex}].days`]:
										"Select at least one visiting day.",
								};
							}
							if (!lastSchedule.startTime) {
								newErrors[`physicianInfo[${physicianIndex}]`] = {
									...newErrors[`physicianInfo[${physicianIndex}]`],
									[`visitingSchedules[${scheduleIndex}].startTime`]:
										"Start time is required.",
								};
							}// Validate incorrect time order (start time greater than end time)
							else if (lastSchedule.startTime && lastSchedule.endTime && lastSchedule.startTime > lastSchedule.endTime) {
								newErrors[`physicianInfo[${physicianIndex}]`][`visitingSchedules[${scheduleIndex}].startTime`] =
									t('error.incorrectTime');
							}
							if (!lastSchedule.endTime) {
								newErrors[`physicianInfo[${physicianIndex}]`] = {
									...newErrors[`physicianInfo[${physicianIndex}]`],
									[`visitingSchedules[${scheduleIndex}].endTime`]:
										"End time is required.",
								};
							}// Validate same time issue
							else if (lastSchedule.startTime && lastSchedule.endTime && lastSchedule.startTime === lastSchedule.endTime) {
								newErrors[`physicianInfo[${physicianIndex}]`][`visitingSchedules[${scheduleIndex}].endTime`] =
									t('error.sameTime');
							}

							return newErrors;
						});

						return physician;
					} else {
						console.log("No errors found, adding a new empty schedule for physician index:", physicianIndex);
						// If there are no errors, add a new empty schedule
						return {
							...physician,
							visitingSchedules: [
								...schedules,
								{ days: [], startTime: null, endTime: null },
							],
						};
					}
				}
				return physician;
			})
		);
	};


	useEffect(() => {
		console.log("PhysicanInof-------->: ", physicianInfo);
	}, [physicianInfo]);


	// Remove Visiting Schedule
	const removeVisitingSchedule = async (physicianIndex, scheduleIndex) => {
		setIndexValue(physicianIndex);
		setRowIndexValue(scheduleIndex);
		const physician = physicianInfo[physicianIndex].physician;
		const days = physicianInfo[physicianIndex].visitingSchedules[scheduleIndex].days;
		const startTime = physicianInfo[physicianIndex].visitingSchedules[scheduleIndex].startTime;
		const endTime = physicianInfo[physicianIndex].visitingSchedules[scheduleIndex].endTime;
		const outofoffice = [];
		const timeZoneValue = physicianInfo[physicianIndex].timeZone;
		// Call the function to handle API request and modal trigger
		const isBooked = await handleBookedAppointmentCheck(physician, days, startTime, endTime, outofoffice, (appointments) => {
			setBookedAppointments(appointments);
			setModalModule('days_hospital');
			setModalVisible(true);  // Show the modal with booked appointments
		}, timeZoneValue);
		// If the appointment is booked, don't continue with the rest of the logic
		if (isBooked) {
			return;
		}
		console.log(`Removing schedule at index ${scheduleIndex} for physician at index ${physicianIndex}`);

		setPhysicianInfo((prev) => {
			const updatedPhysicianInfo = prev.map((physician, i) => {
				if (i === physicianIndex) {
					console.log("Physician before removing schedule:", physician);

					const updatedSchedules = physician.visitingSchedules.filter((_, idx) => idx !== scheduleIndex);

					console.log(`Schedule at index ${scheduleIndex} removed.`);
					console.log("Updated schedules after removal:", updatedSchedules);

					// Return updated physician object
					return {
						...physician,
						visitingSchedules: updatedSchedules,
					};
				}

				// Return unchanged for other physicians
				return physician;
			});

			console.log("Updated physician info after schedule removal:", updatedPhysicianInfo);
			return updatedPhysicianInfo; // Update state with the modified array
		});
	};


	// Function to handle navigation to Add Physician page
	const goToAddPhysician = () => {
		navigate('/admin/add-physician', {
			state: { id }  // Pass hospitalId via navigation state
		});
	};

	// Initialize the selectedPhysicianId state with physician IDs from physicianInfo
	const [selectedPhysicianId, setSelectedPhysicianId] = useState(() => {
		// Check if physicianInfo has valid physician IDs
		return physicianInfo.map((item) => item.physician || ''); // Default to empty string if no physician
	});


	const formatTimeToHHMM = (time) => {
		return moment(time).format("HH:mm");
	};


	// Handle changes in visiting start/end times
	const handleVisitingTimeChange = async (time, scheduleIndex, physicianIndex, field) => {
		setIndexValue(physicianIndex);
		setRowIndexValue(scheduleIndex);
		const physician = physicianInfo[physicianIndex].physician;
		const days = physicianInfo[physicianIndex].visitingSchedules[scheduleIndex].days;
		const startTimeValue = field === 'startTime' ? convert_DateToTime(time) : physicianInfo[physicianIndex].visitingSchedules[scheduleIndex].startTime;
		const outofoffice = [];
		const timeZoneValue = physicianInfo[physicianIndex].timeZone;
		const endTimeValue = field === 'endTime' ? convert_DateToTime(time) : physicianInfo[physicianIndex].visitingSchedules[scheduleIndex].endTime;
		const consultingDuration = parseInt(physicianInfo[physicianIndex].consultingDuration, 10); // Convert consultingDuration to an integer

		if (field === 'endTime') {
			const newEndTimeValue = convert_DateToTime(time); // New end time based on the current time
			const originalEndTimeValue = physicianInfo[physicianIndex].endTime; // Existing end time

			// Adjust newEndTimeValue by subtracting consultingDuration minutes
			let adjustedNewEndTimeValue = moment(newEndTimeValue, 'HH:mm')
				.subtract(consultingDuration, 'minutes') // Subtract consultingDuration in minutes
				.format('HH:mm'); // Format back to HH:mm

			// Initialize variables to store API responses
			let newEndTimeAppointments = [];
			let originalEndTimeAppointments = [];

			// Call the API with the new end time
			const isBookedWithNewEndTime = await handleBookedAppointmentCheck(
				physician,
				days,
				startTimeValue,
				adjustedNewEndTimeValue,
				[],
				(appointments) => {
					newEndTimeAppointments = appointments; // Capture the appointments
				}, timeZoneValue, 'time_hospital'
			);
			// Call the API with the original end time
			const isBookedWithOriginalEndTime = await handleBookedAppointmentCheck(
				physician,
				days,
				startTimeValue,
				originalEndTimeValue,
				[],
				(appointments) => {
					originalEndTimeAppointments = appointments; // Capture the appointments
				}, timeZoneValue, 'time_hospital'
			);
			// Compare the responses
			if (isBookedWithNewEndTime !== isBookedWithOriginalEndTime || (newEndTimeAppointments.length !== originalEndTimeAppointments.length)) {
				// Find missing appointments by comparing the 'id' values
				const missingAppointmentsFromNewEndTime = originalEndTimeAppointments.filter(original =>
					!newEndTimeAppointments.some(newApp => newApp.id === original.id)
				);
				const missingAppointmentsFromOriginalEndTime = newEndTimeAppointments.filter(newApp =>
					!originalEndTimeAppointments.some(original => original.id === newApp.id)
				);
				// Combine the missing appointments
				const missingAppointments = [
					...missingAppointmentsFromNewEndTime,
					...missingAppointmentsFromOriginalEndTime
				];
				// Set the missing appointments
				setBookedAppointments(missingAppointments);
				// Show the modal if the booking status differs
				setModalModule('time_hospital');
				setModalVisible(true); // Show the modal
				return; // Stop further execution
			}
		}

		let outsideTimeAppointments = [];
		const isBooked = await handleBookedAppointmentCheck(
			physician,
			days,
			startTimeValue,
			endTimeValue,
			outofoffice,
			(appointments) => {
				// Convert start and end times to Moment objects (24-hour format) for comparison
				const startMoment = moment(startTimeValue, 'HH:mm');
				const endMoment = moment(endTimeValue, 'HH:mm');
				// Filter appointments that are outside the new time range
				outsideTimeAppointments = appointments.filter((appointment) => {
					const appointmentTime = moment.utc(appointment.time); // Convert appointment time to Moment object
					const appointmentTimeFormatted = appointmentTime.format('HH:mm'); // Convert to HH:mm format for comparison
					// Convert appointmentTimeFormatted back to a moment object for comparison
					const appointmentTimeMoment = moment(appointmentTimeFormatted, 'HH:mm');
					// Compare appointment time with the new time range in HH:mm format
					return appointmentTimeMoment.isBefore(startMoment) || appointmentTimeMoment.isAfter(endMoment);
				});
				// If there are appointments outside the new time range, show the modal
				if (outsideTimeAppointments.length > 0) {
					setBookedAppointments(outsideTimeAppointments);
					setModalModule('time_hospital');
					setModalVisible(true); // Show the modal with booked appointments
				}
			}, timeZoneValue, 'time_hospital'
		);
		// Stop further execution if the modal logic is triggered
		if (isBooked && outsideTimeAppointments.length > 0) {
			return; // Prevent further execution if there are outside appointments
		}

		const formattedTime = formatTimeToHHMM(time);
		setPhysicianInfo((prevPhysicianInfo) => {
			const updatedPhysicianInfo = prevPhysicianInfo.map((physician, idx) => {
				if (idx !== physicianIndex) return physician;

				const updatedSchedules = physician.visitingSchedules?.map((schedule, sIdx) => {
					if (sIdx !== scheduleIndex) return schedule;

					return {
						...schedule,
						[field]: formattedTime,
					};
				}) || [];

				return {
					...physician,
					visitingSchedules: updatedSchedules,
				};
			});

			const updatedSchedule = updatedPhysicianInfo[physicianIndex]?.visitingSchedules?.[scheduleIndex];
			const { startTime, endTime } = updatedSchedule || {};

			// Check for overlap only if the schedule is defined
			const hasOverlap = updatedSchedule
				? checkScheduleOverlap(
					updatedPhysicianInfo[physicianIndex]?.visitingSchedules,
					updatedSchedule,
					scheduleIndex
				)
				: false;

			setPhysicianError((prevErrors) => {
				const newErrors = { ...prevErrors };

				// Ensure the nested error structure exists
				if (!newErrors[`physicianInfo[${physicianIndex}]`]) {
					newErrors[`physicianInfo[${physicianIndex}]`] = {};
				}

				// Handle overlap error
				if (hasOverlap) {
					newErrors[`physicianInfo[${physicianIndex}].visitingSchedules[${scheduleIndex}].overlap`] = `${t('common.scheduleOverlap')}`;
					if(field === "startTime" && updatedSchedule){
						updatedSchedule.startTime="";
					} else if(field === "endTime"){
						updatedSchedule.endTime="";
					}
				} else {
					delete newErrors[`physicianInfo[${physicianIndex}].visitingSchedules[${scheduleIndex}].overlap`];
				}

				// Validation for same time
				if (startTime && endTime && startTime === endTime) {
					newErrors[`physicianInfo[${physicianIndex}]`][`visitingSchedules[${scheduleIndex}].startTime`] =
						t('error.sameTime');
					newErrors[`physicianInfo[${physicianIndex}]`][`visitingSchedules[${scheduleIndex}].endTime`] =
						t('error.sameTime');
				} else {
					delete newErrors[`physicianInfo[${physicianIndex}]`][`visitingSchedules[${scheduleIndex}].startTime`];
					delete newErrors[`physicianInfo[${physicianIndex}]`][`visitingSchedules[${scheduleIndex}].endTime`];
				}

				// Validation for start time greater than end time
				if (startTime && endTime && startTime > endTime) {
					newErrors[`physicianInfo[${physicianIndex}]`][`visitingSchedules[${scheduleIndex}].startTime`] =
						t('error.incorrectTime');
				} else {
					delete newErrors[`physicianInfo[${physicianIndex}]`][`visitingSchedules[${scheduleIndex}].startTime`];
				}

				console.log("Updated Errors:", newErrors); // Debug updated errors
				return newErrors;
			});

			return updatedPhysicianInfo;
		});
	};

	// Handle changes in visiting days
	// const handleVisitingDaysChange = async (e, physicianIndex, scheduleIndex) => {
	// 	setIndexValue(physicianIndex);
	// 	setRowIndexValue(scheduleIndex);
	// 	const { checked, value: day } = e.target;
	// 	if (checked === false) {
	// 		const physician = physicianInfo[physicianIndex].physician;
	// 		const days = [day]; // Create an array with the value
	// 		const startTime = physicianInfo[physicianIndex].visitingSchedules[scheduleIndex].startTime;
	// 		const endTime = physicianInfo[physicianIndex].visitingSchedules[scheduleIndex].endTime;
	// 		const outofoffice = [];
	// 		const timeZoneValue = physicianInfo[physicianIndex].timeZone;
	// 		// Call the function to handle API request and modal trigger
	// 		const isBooked = await handleBookedAppointmentCheck(physician, days, startTime, endTime, outofoffice, (appointments) => {
	// 			setBookedAppointments(appointments);
	// 			setModalModule('day_hospital');
	// 			setModalVisible(true);  // Show the modal with booked appointments
	// 			setValueToRemove(day); // Capture the value for later removal
	// 		}, timeZoneValue);
	// 		// If the appointment is booked, don't continue with the rest of the logic
	// 		if (isBooked) {
	// 			return;
	// 		}
	// 	}

	// 	setPhysicianInfo((prevPhysicianInfo) => {
	// 		const updatedPhysicianInfo = prevPhysicianInfo.map((physician, idx) => {
	// 			if (idx !== physicianIndex) return physician;

	// 			const updatedSchedules = physician.visitingSchedules?.map((schedule, sIdx) => {
	// 				if (sIdx !== scheduleIndex) return schedule;

	// 				const updatedDays = checked
	// 					? [...(schedule.days || []), day]
	// 					: schedule.days.filter((d) => d !== day);

	// 				return { ...schedule, days: updatedDays };
	// 			}) || [];

	// 			return { ...physician, visitingSchedules: updatedSchedules };
	// 		});

	// 		// Check for overlap only if the schedule is defined
	// 		const updatedSchedule = updatedPhysicianInfo[physicianIndex]?.visitingSchedules?.[scheduleIndex];
	// 		const hasOverlap = updatedSchedule
	// 			? checkScheduleOverlap(
	// 				updatedPhysicianInfo[physicianIndex]?.visitingSchedules,
	// 				updatedSchedule,
	// 				scheduleIndex
	// 			)
	// 			: false;

	// 		// Update errors for overlaps or clear them
	// 		setPhysicianError((prevErrors) => {
	// 			const newErrors = { ...prevErrors };
	// 			if (hasOverlap) {
	// 				newErrors[`physicianInfo[${physicianIndex}].visitingSchedules[${scheduleIndex}].overlap`] = `${t('common.scheduleOverlap')}`;
	// 			} else {
	// 				console.log("Clearing overlap error for physician:", physicianIndex);
	// 				delete newErrors[`physicianInfo[${physicianIndex}].visitingSchedules[${scheduleIndex}].overlap`];
	// 			}

	// 			// Clear specific day errors
	// 			if (updatedSchedule?.days?.length > 0) {
	// 				delete newErrors[`physicianInfo[${physicianIndex}]`]?.[
	// 					`visitingSchedules[${scheduleIndex}].days`
	// 				];
	// 			}

	// 			return newErrors;
	// 		});

	// 		return updatedPhysicianInfo;
	// 	});
	// };

	// Handle changes in visiting days
	const handleVisitingDaysChange = async (e, physicianIndex, scheduleIndex) => {
		setIndexValue(physicianIndex);
		setRowIndexValue(scheduleIndex);
		const { checked, value: day } = e.target;
	
		// Extract current schedule information
		const currentPhysician = physicianInfo[physicianIndex];
		const currentSchedule = currentPhysician.visitingSchedules[scheduleIndex];
		const { startTime, endTime } = currentSchedule;
	
		// Check for overlap before proceeding
		const potentialDays = checked
			? [...(currentSchedule.days || []), day] // Add the day
			: currentSchedule.days?.filter((d) => d !== day); // Remove the day
	
		const hasOverlap = checkScheduleOverlap(
			currentPhysician.visitingSchedules,
			{ ...currentSchedule, days: potentialDays },
			scheduleIndex
		);
	
		if (hasOverlap) {
			// Prevent day selection if overlap exists
			setPhysicianError((prevErrors) => ({
				...prevErrors,
				[`physicianInfo[${physicianIndex}].visitingSchedules[${scheduleIndex}].overlap`]:
					`${t('common.scheduleOverlap')}`,
			}));
			return;
		}else{
			// Clear the overlap error if no conflict
			setPhysicianError((prevErrors) => {
				const newErrors = { ...prevErrors };
				delete newErrors[`physicianInfo[${physicianIndex}].visitingSchedules[${scheduleIndex}].overlap`];
				return newErrors;
			});
		}
		
	
		// Handle unchecking a day with booked appointments
		if (checked === false) {
			const physician = currentPhysician.physician;
			const days = [day];
			const outofoffice = [];
			const timeZoneValue = currentPhysician.timeZone;
	
			const isBooked = await handleBookedAppointmentCheck(
				physician,
				days,
				startTime,
				endTime,
				outofoffice,
				(appointments) => {
					setBookedAppointments(appointments);
					setModalModule("day_hospital");
					setModalVisible(true);
					setValueToRemove(day);
				},
				timeZoneValue
			);
	
			if (isBooked) {
				return;
			}
		}
	
		// Update state if no overlap
		setPhysicianInfo((prevPhysicianInfo) => {
			const updatedPhysicianInfo = prevPhysicianInfo.map((physician, idx) => {
				if (idx !== physicianIndex) return physician;
	
				const updatedSchedules = physician.visitingSchedules?.map((schedule, sIdx) => {
					if (sIdx !== scheduleIndex) return schedule;
	
					const updatedDays = checked
						? [...(schedule.days || []), day]
						: schedule.days.filter((d) => d !== day);
	
					return { ...schedule, days: updatedDays };
				}) || [];
	
				return { ...physician, visitingSchedules: updatedSchedules };
			});
	
			// Clear specific day errors if valid
			setPhysicianError((prevErrors) => {
				const newErrors = { ...prevErrors };
				delete newErrors[`physicianInfo[${physicianIndex}].visitingSchedules[${scheduleIndex}].days`];
				return newErrors;
			});
	
			return updatedPhysicianInfo;
		});
	};
	


	useEffect(() => {
		console.log("Updated errorPhysician:", errorPhysician);
	}, [errorPhysician]);


	function processExistingPhysicianInfo(physicianInfo) {
		return Object.values(
			physicianInfo.reduce((acc, physician) => {
				const physicianId = physician.physician;

				if (!acc[physicianId]) {
					acc[physicianId] = {
						name: physician.name,
						physicianId: physician.physician,
						visitingSchedules: [],
					};
				}

				// Merge the visitingSchedules safely
				acc[physicianId].visitingSchedules = [
					...(Array.isArray(acc[physicianId].visitingSchedules) ? acc[physicianId].visitingSchedules : []),
					...(Array.isArray(physician.visitingSchedules) ? physician.visitingSchedules : []),
				];

				return acc;
			}, {})
		);
	}

	const handleTabClick = async (targetTab) => {
		if (targetTab === 0) {
			setTab(0);
			return;
		}

		const ok = await checkHospitalMobile();
		if (ok) {
			setTab(targetTab);
		} else {
			setTab(0); // force back to first tab if invalid
		}
	};

	return (
		<main id="main" className="main">
			{/*import ImageCroper*/}
			<ImageCroper
				show={show}
				handleClose={handleClose}
				image={image}
				cropImge={imageData}
			/>
			<AllAppointmentsCancelModal
				show={modalVisible}
				onHide={() => setModalVisible(false)}
				module={modalModule}
				bookedAppointments={bookedAppointments}
				onNo={() => setModalVisible(false)}
				indexValue={indexValue} // Pass the index
				hospitalInfo={physicianInfo} // Pass hospitalInfo
				setHospitalInfo={setPhysicianInfo} // Pass setHospitalInfo
				valueToRemove={valueToRemove} // Pass valueToRemove
				physicianData={data} // Pass data
				setData = {setData} // Pass setData
				rowIndexValue={rowIndexValue} // Pass the row index
			/>
			{/*Page Title Section*/}
			<div className="pagetitle clearfix">
				<div className="float-start">
					<h1>{t('profile.editHospitalInfo')}</h1>
					<nav>
						<ol className="breadcrumb">
							<li className="breadcrumb-item"><Link to='/admin/dashboard'>{t('sidebar.home')}</Link></li>
							<li className="breadcrumb-item"><Link to='/admin/hospital'>{t('sidebar.hospital')}</Link></li>
							<li className="breadcrumb-item active">{t('profile.editHospitalInfo')} </li>
						</ol>
					</nav>
				</div>
				<div className="float-end mt-2 me-1">
					<span onClick={goBack} className="backIcon"><i className="iconly-Bold-ArrowLeftSquare"></i></span>
				</div>
			</div>
			{/*End Page Title Section*/}

			{/*Page Content Section*/}
			<section>
				<div className="row">
					{/*ProfileImg*/}
					<div className="col-xxl-3">
						<div className="card profile-img">
							<div className="card-body">
								<div className="upload-box d-none d-lg-block">
									<div className="box text-center" onDrop={handleDrop} onDragOver={handleDrag}>
										<input type="file" onChange={handleFile} name="file-6[]" id="file-6" className="inputfile inputfile-4" />
										<label htmlFor="file-6">
											{cropImge && (<img className="img-fluid d-block mx-auto" src={cropImge} alt="lo" />)}
											{(!cropImge && data && data?.photo && data?.photo === 'default.png') && <img className="img-fluid d-block mx-auto" src="/assets/img/logo-img.png" alt="IMG" />}
											{(!cropImge && data && data?.photo && data?.photo !== 'default.png') && <img src={convertS3privateToPublic(data?.photo)} className="img-fluid d-block mx-auto" alt="IMG" />}
											<span>{t('common.editChange')} <br /> ({t('common.dragDrop')})</span>
										</label>
									</div>
								</div>
								<div className="text-center text-tmBlue mt-4">
									<h6>{t('profile.uploadPicture')}</h6>
								</div>
							</div>
						</div>
					</div>

					{/*Organization Info*/}
					<div className="col-xxl-9">
						<div className="card form-card profile-info ">
							<div className="card-body pt-4">
								<ul className="nav nav-pills nav-fill mb-4" id="pills-tab" role="tablist">
									<li className="nav-item" role="presentation">
										<span 
											onClick={() => handleTabClick(0)} 
											className={tab === 0 ? "nav-link active" : "nav-link"} 
											type="button" 
											role="tab"
										>
											{t('profile.organisationInfo')}
										</span>
										</li>

										<li className="nav-item" role="presentation">
										<span 
											onClick={() => handleTabClick(1)} 
											className={tab === 1 ? "nav-link active" : "nav-link"} 
											type="button" 
											role="tab"
										>
											{t('profile.adminInfo')}
										</span>
										</li>

										<li className="nav-item" role="presentation">
										<span 
											onClick={() => handleTabClick(2)} 
											className={tab === 2 ? "nav-link active" : "nav-link"} 
											type="button" 
											role="tab"
										>
											{t('profile.physicianInfo')}
										</span>
										</li>

										<li className="nav-item" role="presentation">
										<span 
											onClick={() => handleTabClick(3)} 
											className={tab === 3 ? "nav-link active" : "nav-link"} 
											type="button" 
											role="tab"
										>
											{t('profile.parentInfo')}
										</span>
										</li>

								</ul>
								<div className="tab-content">
									{/*TAB-01*/}
									{tab === 0 && <div>
										<form autoComplete="off">
											<div className="row">
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
														<label>{t('profile.organisationName')} </label>
														<input onChange={handleChange} value={data.name ? data.name.trim() : ''} name="name" type="text" className="form-control" placeholder={t('profile.organisationName')} />
														{error && error.name && <span className="required">{error.name}</span>}
													</div>

												</div>
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
														<label>{t('profile.organisationWebsite')}</label>
														<input onChange={handleChange} value={data.website ? data.website.trim() : ''} name="website" type="text" className="form-control" placeholder={t('profile.organisationWebsite')} />
														{error && error.website && <span className="required">{error.website}</span>}
													</div>
												</div>
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
														<label>{t('profile.phoneNumber')}</label>
														<PhoneInput
															inputProps={{
																name: 'mobileNumber',
																style: { width: '100%' }
															}}
															country={'us'}
															value={data?.mobileNumberWithCode ? data?.mobileNumberWithCode : ''}
															onChange={handlePhone}
														/>
														{error && error.mobileNumber && <span className="required">{error.mobileNumber}</span>}
														{!isValid && !error.mobileNumber && <span className="required">Enter Valid Number</span>}
													</div>
												</div>
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
														<label>{t('profile.emailAddress')}</label>
														<input onChange={handleChange} value={data.email ? data.email : ''} name="email" type="text" className="form-control" placeholder="youremail@mail.com" />
														{error && error.email && <span className="required">{error.email}</span>}
													</div>
												</div>
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
														<label>{t('profile.addressOne')}</label>
														<input onChange={handleChange} value={data.address_one ? data.address_one : ''} name="address_one" type="text" className="form-control" placeholder={t('common.addressLine1')} />
														{error && error.address_one && <span className="required">{error.address_one}</span>}
													</div>
												</div>
												<div className="col-lg-6 col-md-6">
													<div className=" form-group">
														<label>{t('profile.addressTwo')}</label>
														<input onChange={handleChange} value={data.address_two ? data.address_two : ''} name="address_two" type="text" className="form-control" placeholder={t('common.addressLine2')} />
														{error && error.address_two && <span className="required">{error.address_two}</span>}
													</div>
												</div>
												<div className="col-lg-4 col-md-6">
													<div className=" form-group">
														<label>{t('profile.city')} </label>
														<Autocomplete
															value={data?.city ? data.city : ''}
															className="form-control"
															placeholder={t('common.city')}
															onChange={changeCity}
															onPlaceSelected={selectCity}
															types={['(cities)']}
														/>
														{error && error.city && <span className="required">{error.city}</span>}
													</div>
												</div>
												<div className="col-lg-4 col-md-6">
													<div className=" form-group">
														<label>{t('profile.state')} </label>
														<input onChange={handleChange} readOnly value={data.state ? data.state : ''} name="state" type="text" className="form-control" placeholder={t('common.state')} />
														{error && error.state && !data.state && <span className="required">{error.state}</span>}
													</div>
												</div>
												<div className="col-lg-4 col-md-6">
													<div className=" form-group">
														<label>{t('profile.zipCode')} </label>
														<input onChange={handleChange} value={data.zipcode ? data.zipcode : ''} name="zipcode" type="text" className="form-control" placeholder={t('common.zipCode')} />
														{error && error.zipcode && <span className="required">{error.zipcode}</span>}
													</div>
												</div>
											</div>
											{/*Prev-Next Button Section*/}
											<div className="row mt-3">
												<div className="col-lg-12 text-end">
													<button onClick={goNext(0)} type="button" className="btn btn-tmBlue btnNext"><i className="iconly-Light-ArrowRight align-middle"></i> {t('profile.next')}</button>
												</div>
											</div>
										</form>
									</div>}

									{/*TAB-02*/}
									{tab === 1 && <div >
										<form>
											<div className="row">
												<div className="col-lg-12">
													<div className="form-group row">
														<div className="col-lg-6 col-md-6">
															<div className=" form-group">
																<label>{t('profile.firstName')} </label>
																<input onChange={handleChange} value={data.admin_first_name ? data.admin_first_name.trim() : ''} name="admin_first_name" type="text" className="form-control" placeholder={t('profile.firstName')} />
																{error && error.admin_first_name && <span className="required">{error.admin_first_name}</span>}
															</div>
														</div>
														<div className="col-lg-6 col-md-6">
															<div className=" form-group">
																<label>{t('profile.lastName')} </label>
																<input onChange={handleChange} value={data.admin_last_name ? data.admin_last_name.trim() : ''} name="admin_last_name" type="text" className="form-control" placeholder={t('profile.lastName')} />
																{error && error.admin_last_name && <span className="required">{error.admin_last_name}</span>}
															</div>
														</div>
														<div className="col-lg-6 col-md-6">
															<div className=" form-group">
																<label>{t('profile.role')} </label>
																<input defaultValue="Admin" type="text" className="form-control" placeholder="Admin Role" disabled />
															</div>
														</div>
														<div className="col-lg-6 col-md-6">
															<div className=" form-group">
																<label>{t('profile.phoneNumber')}</label>
																<PhoneInput
																	inputProps={{
																		name: 'admin_mobileNumber',
																		style: { width: '100%' }
																	}}
																	country={'us'}
																	value={data?.admin_mobileNumberWithCode ? data?.admin_mobileNumberWithCode : ''}
																	onChange={handlePhone}
																/>
																{/* 												{error && error.admin_mobileNumber && <span className="required">{error.admin_mobileNumber}</span>} */}
																{!isValid && !error.admin_mobileNumber && <span className="required">{t('error.validPhoneNumber')}</span>}
															</div>
														</div>
														<div className="col-lg-6 col-md-6">
															<div className=" form-group">
																<label>{t('profile.emailAddress')} </label>
																<input onChange={handleChange} value={data.admin_email ? data.admin_email : ''} name="admin_email" type="text" className="form-control" placeholder="youremail@mail.com" />
																{error && error.admin_email && <span className="required">{error.admin_email}</span>}
															</div>
														</div>
														{/* <div className="col-lg-6 col-md-6">
															<div className=" form-group">
																<label>{t('profile.gender}</label>
																<select name="admin_gender" value={data?.admin_gender ? data.admin_gender : ''} onChange={handleChange} className="form-select">
																	<option value='' disabled>{t('profile.selectGender}</option>
																	<option value="0" >{t('profile.male}</option>
																	<option value="1" >{t('profile.female}</option>
																</select>
																{error && error.admin_gender && <span className="required">{error.admin_gender}</span>}
															</div>
														</div> */}
														<div className="col-lg-12">
															<div className=" form-group">
																<label>{t('profile.webURL')}</label>
																<input defaultValue={data?.website} type="text" className="form-control bg-light" disabled />
															</div>
														</div>
													</div>
												</div>
											</div>
											{/*Prev-Next Button Section*/}
											<div className="row">
												<div className="col-lg-12 text-end">
													<button onClick={() => setTab(0)} type="button" className="btn btn-secondary btnPrev me-2"><i className="ri-arrow-left-line align-middle"></i> {t('profile.prev')}</button>
													<button onClick={goNext(1)} type="button" className="btn btn-tmBlue btnNext"><i className="ri-arrow-right-line align-middle"></i> {t('profile.next')}</button>
												</div>
											</div>
										</form>
									</div>}

									{/*TAB-03*/}
									{tab === 2 && <div >
										<form>
											<div className="row">
												<div className="col-lg-12">
													{physicianInfo && physicianInfo.map((item, i) => {
														if (!uniquePhysicians.has(item.physician)) {
															uniquePhysicians.add(item.physician);
															return (
																<div
																	key={i}
																	id={item.physician}
																	className="form-group row"
																>
																	<div className="col-lg-5 col-md-6 mb-3">
																		<label>{t('sidebar.physician')} </label>
																		<Select
																			value={
																				users?.physician
																					.filter(option => option.account === item.physician)
																					.map(option => ({
																						value: option.account,
																						label: `${option.first_name} ${option.last_name}`,
																					}))[0] || null
																			}
																			name="physician"
																			onChange={(selectedOption) => {
																				const updatedPhysicianId = [...selectedPhysicianId];

																				// If the same physician is selected, unselect it
																				if (selectedOption?.value === item.physician) {
																					// updatedPhysicianId[i] = null;  // Unselect this physician
																					return;
																				} else {
																					updatedPhysicianId[i] = selectedOption?.value;  // Select new physician
																				}

																				setSelectedPhysicianId(updatedPhysicianId);
																				changePhysicianInfo(i)({
																					target: { name: "physician", value: selectedOption?.value },
																				});
																				// Reset the fields for the changed physician
																				const resetPhysicianInfo = physicianInfo.map((info, idx) => {
																					if (idx === i) {
																						return {
																							hospital: id,
																							physician: selectedOption?.value || '',
																							days: [],
																							startTime: '',
																							endTime: '',
																							timeZone: systemTimeZone,
																							consultingDuration: '',
																							out_of_office: ['[]'],
																							visitingSchedules: [{
																								days: [],
																								startTime: '',
																								endTime: '',
																							}],
																						};
																					}
																					return info;
																				});

																				setPhysicianInfo(resetPhysicianInfo);
																				setPhysicianError({}); // Clear any errors for the physician fields
																			}}
																			options={
																				users?.physician
																					?.filter(option => !selectedPhysicianId.includes(option.account) || selectedPhysicianId[i] === option.account)  // Include unselected physicians back in dropdown
																					.map(item => ({
																						value: item.account,
																						label: `${item.first_name} ${item.last_name}`,
																					})) || []
																			}
																			placeholder={t('common.selectPhysician')}
																			classNamePrefix="react-select"
																		/>
																		{errorPhysician && errorPhysician.physician && i === physicianInfo.length - 1 && <span className="required">{errorPhysician.physician}</span>}
																	</div>
																	{/* Consulting Duration */}
																	<div className="col-lg-3 col-md-6 mb-3">
																		<label>{t('table.consultingDuration')}</label>
																		<select
																			className="form-select"
																			name="consultingDuration"
																			value={item.consultingDuration || ''}
																			onChange={changePhysicianInfo(i)}
																		>
																			<option value="" disabled>{t('profile.selectConsultingDuration')}</option>
																			<option value="10">10 {t('common.mins')}</option>
																			<option value="15">15 {t('common.mins')}</option>
																			<option value="20">20 {t('common.mins')}</option>
																			<option value="25">25 {t('common.mins')}</option>
																			<option value="30">30 {t('common.mins')}</option>
																		</select>
																		{errorPhysician && errorPhysician.consultingDuration && i === physicianInfo.length - 1 && (
																			<span className="required">{errorPhysician.consultingDuration}</span>
																		)}
																	</div>
																	<div className="col-lg-3 col-md-2 d-flex align-items-center">
																		<button
																			onClick={removePhysicianInfo(i)}
																			type="button"
																			className="btn btn-outline-danger py-2 me-2 d-flex align-items-center"
																		>
																			<i className="ri-close-fill me-1"></i>
																			{t('common.removePhysician')}
																		</button>
																		{/* Add the second button if necessary */}
																	</div>
																	<div className="col-lg-5 col-md-4 mb-3">
																		<label>{t('profile.timeZone')}</label>
																		<div key={i}>
																			<TimezoneSelect
																				name="timeZone"
																				value={item.timeZone ? item.timeZone : systemTimeZone} // Use system time zone if not already selected
																				onChange={(value) => changeTimeZone(value, i)}
																				labelStyle="altName"
																			/>
																		</div>
																		{errorPhysician && errorPhysician.timeZone && i === physicianInfo.length - 1 && <span className="required">{errorPhysician.timeZone}</span>}
																	</div>
																	<div>
																		{/* {console.log("Rendering physicianInfo:", physicianInfo)} */}
																		{processExistingPhysicianInfo(physicianInfo).map((group, physicianIndex) => {
																			const { name, visitingSchedules, physicianId } = group; // Destructure to get physicianId here																			
																			if (physicianInfo.length > 1) {
																				const shouldDisplay = physicianId !== selectedPhysicianId[i];
																				if (shouldDisplay) return null;
																			}
																			console.log("Rendering visitingSchedules:", visitingSchedules);
																			return (
																				<div
																					key={physicianId}
																					id={physicianId || `${physicianIndex}`} // Use a default ID if physician is null/empty
																					className="form-group row"
																				>
																					{/* <h3>{name}</h3> Display physician's name */}
																					{/* Render Visiting Schedules */}
																					{visitingSchedules.map((schedule, scheduleIndex) => (
																						<div key={`${physicianIndex}-${scheduleIndex}`} className="row mb-3">
																							{/* Visiting Days */}
																							<div className="col-lg-5.5 col-md-6 mb-3">
																								<label>{t('common.visitingDays')}</label>
																								<div className="form-group mb-0 checkRadio-bg">
																									{["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].map((day, idx) => {
																										return (
																											<div key={idx} className="form-check form-check-inline">
																												<input
																													className="form-check-input days_Admin"
																													type="checkbox"
																													name="DaysOptions"
																													id={`DaysOptions${physicianIndex}-${scheduleIndex}-${idx}`}
																													value={day}
																													checked={Array.isArray(schedule.days) && schedule.days.includes(day)}
																													onChange={(e) => handleVisitingDaysChange(e, physicianIndex, scheduleIndex)}
																												/>
																												<label className="form-check-label" htmlFor={`DaysOptions${physicianIndex}-${scheduleIndex}-${idx}`}>
																													{t(`common.${day.slice(0, 2).toLowerCase()}`)}
																												</label>
																											</div>
																										);
																									})}
																								</div>
																								{/* Show error message for visitingSchedules[${scheduleIndex}].days */}
																								{errorPhysician &&
																									errorPhysician[`physicianInfo[${physicianIndex}]`] &&
																									errorPhysician[`physicianInfo[${physicianIndex}]`][`visitingSchedules[${scheduleIndex}].days`] && (
																										<span className="required">
																											{errorPhysician[`physicianInfo[${physicianIndex}]`][`visitingSchedules[${scheduleIndex}].days`]}
																										</span>
																									)
																								}
																							</div>
																							{/* Visiting Hours */}
																							<div className="col-lg-3 col-md-4 mb-3">
																								<label>{t('profile.visitingHours')}</label>
																								<div className="d-flex align-items-center">
																									<div style={{ minWidth: '120px' }}>
																										<DatePicker
																											format="hh:mm aa"
																											value={schedule.startTime ? convertTimeToDate(schedule.startTime) : null}
																											showMeridian
																											onSelect={(time) => {
																												console.log(`Start time changed for schedule ${scheduleIndex}:`, time);
																												handleVisitingTimeChange(time, scheduleIndex, physicianIndex, "startTime");
																											}}
																											cleanable={false}
																											style={{ width: '100%' }}
																										/>
																										{errorPhysician &&
																											errorPhysician[`physicianInfo[${physicianIndex}]`] &&
																											errorPhysician[`physicianInfo[${physicianIndex}]`][`visitingSchedules[${scheduleIndex}].startTime`] && (
																												<span className="required">
																													{errorPhysician[`physicianInfo[${physicianIndex}]`][`visitingSchedules[${scheduleIndex}].startTime`]}
																												</span>
																											)
																										}
																									</div>
																									<div className="my-2 mx-3">-</div>
																									<div style={{ minWidth: '120px' }}>
																										<DatePicker
																											format="hh:mm aa"
																											value={schedule.endTime ? convertTimeToDate(schedule.endTime) : null}
																											showMeridian
																											onSelect={(time) => {
																												console.log(`End time changed for schedule ${scheduleIndex}:`, time);
																												handleVisitingTimeChange(time, scheduleIndex, physicianIndex, "endTime");
																											}}
																											cleanable={false}
																											 style={{ width: '100%' }}
																										/>
																										{errorPhysician &&
																											errorPhysician[`physicianInfo[${physicianIndex}]`] &&
																											errorPhysician[`physicianInfo[${physicianIndex}]`][`visitingSchedules[${scheduleIndex}].endTime`] && (
																												<span className="required">
																													{errorPhysician[`physicianInfo[${physicianIndex}]`][`visitingSchedules[${scheduleIndex}].endTime`]}
																												</span>
																											)
																										}
																									</div>
																								</div>
																							</div>
																							{/* Add New Visiting Schedule button */}
																							<div
																								className="col-lg-1 col-md-2 d-flex align-items-center w-100"
																							>
																								{visitingSchedules.length > 0 && (
																									<button
																										type="button"
																										className="btn btn-outline-danger"
																										style={{ marginRight: "20px" }}
																										onClick={() => removeVisitingSchedule(physicianIndex, scheduleIndex)}
																									>
																										<i className="ri-close-fill"></i>
																									</button>
																								)}
																								{scheduleIndex === visitingSchedules.length - 1 && (
																									<button
																										type="button"
																										className="btn btn-outline-tmBlue"
																										onClick={() => {
																											console.log(`Adding new visiting schedule for physician ${physicianIndex}`);
																											addVisitingSchedule(physicianIndex);
																										}}
																									>
																										<i className="ri-add-fill"></i>
																									</button>
																								)}
																							</div>
																							{/* Show a single error message if no visiting schedules */}
																							{/* {errorPhysician && errorPhysician.visitingSchedules && errorPhysician.visitingSchedules[0] === "Visiting schedule is required" && (
																								<div className="required">
																									Visiting schedule is required
																								</div>
																							)} */}
																							 {errorPhysician &&
																								errorPhysician[`physicianInfo[${physicianIndex}].visitingSchedules[${scheduleIndex}].overlap`] && (
																									<div className="col-12">
																									<span className="required">
																										{errorPhysician[`physicianInfo[${physicianIndex}].visitingSchedules[${scheduleIndex}].overlap`]}
																									</span>
																									</div>
																								)
																								}
																						</div>
																						//))
																					))}
																					{/* If there is no schedule or while adding a new physician */}
																					{visitingSchedules.length === 0 && (
																						// If there is no schedule or while adding a new physician
																						<div key="new-schedule" className="row mb-3">
																							{/* {console.log(`Rendering new schedule row for physician ${physicianIndex}`)} */}
																							<div className="col-lg-5.5 col-md-6 mb-3">
																								<label>{t('common.visitingDays')}</label>
																								<div className="form-group mb-0 checkRadio-bg">
																									{["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].map((day, idx) => {
																										return (
																											<div key={idx} className="form-check form-check-inline">
																												<input
																													className="form-check-input days_Admin"
																													type="checkbox"
																													name="DaysOptions"
																													id={`DaysOptions${physicianIndex}-new-${idx}`}
																													value={day}
																													onChange={(e) => handleVisitingDaysChange(e, physicianIndex, 0)}
																												/>
																												<label className="form-check-label" htmlFor={`DaysOptions${physicianIndex}-new-${idx}`}>
																													{day.slice(0, 2)}
																												</label>
																											</div>
																										);
																									})}
																								</div>
																							</div>
																							{/* Visiting Hours */}
																							<div className="col-lg-3 col-md-4 mb-3">
																								<label>{t('profile.visitingHours')}</label>
																								<div className="d-flex align-items-center">
																									<div style={{ minWidth: '120px' }}>
																										<DatePicker
																											format="hh:mm aa"
																											value={null}  // No need to check for visitingSchedules[0] for a new row
																											showMeridian
																											cleanable={false}
																											onSelect={(time) => {
																												console.log(`New Start time changed for schedule ${physicianIndex}:`, time);
																												handleVisitingTimeChange(time, 0, physicianIndex, "startTime");
																											}}
																											style={{ width: '100%' }}
																										/>
																										{sameTimeErr[`physicianInfo[${physicianIndex}].startTime`] ? (
																											<span className="required">
																												{sameTimeErr[`physicianInfo[${physicianIndex}].startTime`]}
																											</span>
																										) : errorPhysician?.startTime && physicianIndex === physicianInfo.length - 1 && (
																											<span className="required">
																												{errorPhysician.startTime}
																											</span>
																										)}
																									</div>
																									<div className="my-2 mx-3">To</div>
																									<div style={{ minWidth: '120px' }}>
																										<DatePicker
																											format="hh:mm aa"
																											value={null}  // Similarly, no need to check for visitingSchedules[0] here
																											showMeridian
																											cleanable={false}
																											onSelect={(time) => {
																												console.log(`New End time changed for schedule ${physicianIndex}:`, time);
																												handleVisitingTimeChange(time, 0, physicianIndex, "endTime");
																											}}
																											style={{ width: '100%' }}
																										/>
																										{sameTimeErr[`physicianInfo[${physicianIndex}].endTime`] ? (
																											<span className="required">
																												{sameTimeErr[`physicianInfo[${physicianIndex}].endTime`]}
																											</span>
																										) : errorPhysician?.endTime && physicianIndex === physicianInfo.length - 1 && (
																											<span className="required">
																												{errorPhysician.endTime}
																											</span>
																										)}
																									</div>
																								</div>
																							</div>

																							{/* Add and Remove Buttons */}
																							<div className="col-lg-1 col-md-2 d-flex align-items-center w-100">
																								<button
																									type="button"
																									className="btn btn-outline-danger"
																									style={{ marginRight: '20px' }}
																									onClick={() => {
																										// console.log(`Removing first visiting schedule for physician ${physicianIndex}`);
																										removeVisitingSchedule(physicianIndex, 0);
																									}}
																								>
																									<i className="ri-close-fill"></i>
																								</button>
																								<button
																									type="button"
																									className="btn btn-outline-tmBlue"
																									onClick={() => {
																										console.log(`Empty schedule so Adding new visiting schedule for physician ${physicianIndex}`);
																										addVisitingSchedule(physicianIndex);
																									}}
																								>
																									<i className="ri-add-fill"></i>
																								</button>
																							</div>
																						</div>
																					)}
																					{console.log("ErrorPhysician Object:", errorPhysician)}
																					{console.log("Visiting Schedules for Physician:", errorPhysician[`physicianInfo[${physicianIndex}]`]?.visitingSchedules)}

																					{/* Show a single error message if no visiting schedules */}
																					{errorPhysician &&
																						errorPhysician[`physicianInfo[${physicianIndex}]`] &&
																						errorPhysician[`physicianInfo[${physicianIndex}]`].visitingSchedules &&
																						errorPhysician[`physicianInfo[${physicianIndex}]`].visitingSchedules[0] === "Visiting schedule is required" && (
																							<span className="required" >
																								Visiting schedule is required
																							</span>
																						)
																					}
																					{/*  Display the overlap error */}
																					{/* {errorPhysician && errorPhysician[`physicianInfo[${physicianIndex}].overlap`] && (
																						<span className="required">{errorPhysician[`physicianInfo[${physicianIndex}].overlap`]}</span>
																					)} */}
																					{errorPhysician && errorPhysician[`physicianInfo[${physicianIndex}]`]?.visitingSchedules?.some((schedule, scheduleIndex) => 
																						errorPhysician[`physicianInfo[${physicianIndex}]`][`visitingSchedules[${scheduleIndex}].overlap`]) && (
																						<span className="required">
																							{errorPhysician[`physicianInfo[${physicianIndex}]`]?.visitingSchedules?.map((schedule, scheduleIndex) => 
																							errorPhysician[`physicianInfo[${physicianIndex}]`][`visitingSchedules[${scheduleIndex}].overlap`] &&
																							errorPhysician[`physicianInfo[${physicianIndex}]`][`visitingSchedules[${scheduleIndex}].overlap`]
																							)}
																						</span>
																						)}
																					{/* {console.log(`********** Physician ${physicianIndex + 1} loop completed *********`)}  Log completion of the physician loop */}
																				</div>
																			);
																		})}
																		{/* Show a single error message if no visiting schedules */}
																		{errorPhysician && errorPhysician.visitingSchedules && errorPhysician.visitingSchedules[0] === "Visiting schedule is required" && (
																			<div className="required" style={{ marginTop: '-1.75rem' }}>
																				Visiting schedule is required
																			</div>
																		)}
																	</div>
																	<div className="row mt-4">
																		<div className="col-xxl-12">
																			<div className="secTitle">
																				<h1>Out of Office</h1>
																			</div>
																		</div>
																	</div>
																	{Array.isArray(physicianInfo[i]?.out_of_office) && physicianInfo[i]?.out_of_office.length > 0 ? (
																		physicianInfo[i]?.out_of_office.map((row, dateIndex) => {
																			// Preprocess the stringified array
																			const preprocessRowString = (row) => {
																				if (typeof row === "string" && row.startsWith("[") && row.endsWith("]")) {
																					// Check if the row matches the specific case of "[,]"
																					if (row === "[,]") {
																						return '["",""]'; // Replace with a valid JSON array of two empty strings
																					}
																					// Check if the row is already properly formatted (i.e., dates are already inside quotes)
																					const isAlreadyFormatted = row.match(/"\d{4}-\d{2}-\d{2}"/g);

																					// If it's already properly formatted, do nothing and return the row
																					if (isAlreadyFormatted && isAlreadyFormatted.length === row.match(/\d{4}-\d{2}-\d{2}/g).length) {
																						return row; // Return the row as-is if it's already properly formatted
																					}
																					// Add quotes around each date to make it valid JSON
																					return row.replace(/(\d{4}-\d{2}-\d{2})/g, '"$1"');
																				}

																				return row; // Return as-is if it's not a stringified array
																			};


																			let parsedRow = ["", ""]; // Default to empty dates

																			if (typeof row === "string") {
																				const preprocessedRow = preprocessRowString(row);
																				try {
																					parsedRow = JSON.parse(preprocessedRow); // Parse the corrected JSON
																				} catch (e) {
																					console.error("Error parsing row string:", row, e);
																				}
																			}

																			const [startDate, endDate] = parsedRow;

																			// Helper to format dates for input type="date"
																			const formatInputDate = (date) => {
																				const d = new Date(date);
																				return isNaN(d) || !date ? "" : d.toISOString().split("T")[0]; // Empty string if date is invalid or null
																			};

																			// Format dates for display in DD-MM-YYYY
																			const formatDisplayDate = (date) => {
																				const d = new Date(date);
																				if (isNaN(d)) return "";
																				const day = String(d.getDate()).padStart(2, "0");
																				const month = String(d.getMonth() + 1).padStart(2, "0");
																				const year = d.getFullYear();
																				return `${day}-${month}-${year}`;
																			};

																			const formattedStartDate = formatInputDate(startDate);
																			const formattedEndDate = formatInputDate(endDate);

																			return (
																				<div className="row mb-3 align-items-center" key={dateIndex}>
																					<div className="col-lg-3 col-md-6 flatpicker">
																						<label>{t('modal.startDate')}</label>
																						{/* <input
																							type="date"
																							className="form-control"
																							min={new Date().toISOString().split('T')[0]} // Prevent past dates
																							value={formattedStartDate}
																							onChange={(e) => handleDateChange(i, dateIndex, "startDate", e.target.value)}
																						/> */}
																						{/* <div className="formatted-date">{displayStartDate}</div> */}
																						<div className="input-group">
																							{console.log('formattedStartDate ',formattedStartDate)}
																							<Flatpickr
																								value={formattedStartDate || ""} // Bind the selected date
																								onChange={(selectedDates) =>
																									handleDateChange(i, dateIndex, "startDate", selectedDates[0])
																								}
																								options={{
																									dateFormat: "Y-m-d", // Format of the date
																									minDate: "today", // Minimum date as today
																								}}
																								placeholder={t('profile.selectDate')} // Placeholder text
																								className="form-control" // Optional: Add a CSS class
																								// ref={(el) => (startflatpickrRef.current = el)} // Correctly set ref
																								ref={(el) => {
																									if (!startflatpickrRef.current[`start-${i}-${dateIndex}`]) {
																										startflatpickrRef.current[`start-${i}-${dateIndex}`] = el;
																									}
																								}}
																							/>
																							{/* Calendar Icon */}
																							<span className="input-group-text input-button" title="toggle"
																								// onClick={() => startflatpickrRef.current?.flatpickr?.open()}
																								onClick={() =>
																									startflatpickrRef.current[`start-${i}-${dateIndex}`]?.flatpickr?.open()
																								}
																								>
																								<i className="ri-calendar-line"></i>
																							</span>
																						</div>
																					</div>
																					<div className="col-lg-3 col-md-6 flatpicker">
																						<label>{t('modal.endDate')}</label>
																						{/* <input
																							type="date"
																							className="form-control"
																							min={new Date().toISOString().split('T')[0]} // Prevent past dates
																							value={formattedEndDate}
																							onChange={(e) => handleDateChange(i, dateIndex, "endDate", e.target.value)}
																						/> */}
																						{/* <div className="formatted-date">{displayEndDate}</div> */}
																						<div className="input-group">
																						{console.log('formattedEndDate ',formattedEndDate)}
																							<Flatpickr
																								value={formattedEndDate || ""} // Bind the selected date
																								onChange={(selectedDates) =>
																									handleDateChange(i, dateIndex, "endDate", selectedDates[0])
																								}
																								options={{
																									dateFormat: "Y-m-d", // Format of the date
																									minDate: "today", // Minimum date as today
																								}}
																								placeholder={t('profile.selectDate')} // Placeholder text
																								className="form-control" // Optional: Add a CSS class
																								// ref={(el) => (endflatpickrRef.current = el)} // Correctly set ref
																								ref={(el) => {
																									if (!endflatpickrRef.current[`end-${i}-${dateIndex}`]) {
																										endflatpickrRef.current[`end-${i}-${dateIndex}`] = el;
																									}
																								}}
																							/>
																							{/* Calendar Icon */}
																							<span className="input-group-text input-button" title="toggle"
																								// onClick={() => endflatpickrRef.current?.flatpickr?.open()}
																								onClick={() =>
																									endflatpickrRef.current[`end-${i}-${dateIndex}`]?.flatpickr?.open()
																								}
																								>
																								<i className="ri-calendar-line"></i>
																							</span>
																						</div>
																					</div>
																					<div className="col-lg-4 d-flex align-items-center mt-4">
																						<button
																							type="button"
																							className="btn btn-outline-danger me-2 d-flex align-items-center"
																							onClick={() => removeDateRow(i, dateIndex)}
																						>
																							<i className="ri-close-fill"></i> {t('common.remove')}
																						</button>
																						{dateIndex === physicianInfo[i].out_of_office.length - 1 && (
																							<button
																								type="button"
																								className="btn btn-outline-tmBlue"
																								onClick={() => addDateRow(i)}
																							>
																								<i className="ri-add-fill align-middle"></i> {t('common.addMore')}
																							</button>
																						)}
																					</div>
																					{errorPhysician[`physicianInfo[${i}].out_of_office[${dateIndex}]`] && (
																						<div className="error-message required">
																							{errorPhysician[`physicianInfo[${i}].out_of_office[${dateIndex}]`]}
																						</div>
																					)}
																				</div>
																			);
																		})
																	) : (
																		<div className="row mb-3 align-items-center">
																			<div className="col-lg-3 col-md-6 flatpicker">
																				<label>{t('modal.startDate')}</label>
																				{/* <input
																					type="date"
																					min={new Date().toISOString().split('T')[0]} // Prevent past dates
																					className="form-control"
																					value="" // Empty value initially
																					onChange={(e) => handleDateChange(i, 0, "startDate", e.target.value)}
																				/> */}
																				<div className="input-group">
																					<Flatpickr
																						value="" // Empty value initially
																						onChange={(selectedDates) =>
																							handleDateChange(i, 0, "startDate", selectedDates[0])
																						}
																						options={{
																							dateFormat: "Y-m-d", // Format of the date
																							minDate: "today", // Minimum date as today
																						}}
																						placeholder={t('profile.selectDate')} // Placeholder text
																						className="form-control" // Optional: Add a CSS class
																						// ref={(el) => (startflatpickrRef.current = el)} // Correctly set ref
																						ref={(el) => {
																							if (!startflatpickrRef.current[`start-${i}`]) {
																								startflatpickrRef.current[`start-${i}`] = el;
																							}
																						}}
																					/>
																					{/* Calendar Icon */}
																					<span className="input-group-text input-button" title="toggle"
																						// onClick={() => startflatpickrRef.current?.flatpickr?.open()}
																						onClick={() =>
																							startflatpickrRef.current[`start-${i}`]?.flatpickr?.open()
																						}
																						>
																						<i className="ri-calendar-line"></i>
																					</span>
																				</div>
																			</div>
																			<div className="col-lg-3 col-md-6 flatpicker">
																				<label>{t('modal.endDate')}</label>
																				{/* <input
																					type="date"
																					min={new Date().toISOString().split('T')[0]} // Prevent past dates
																					className="form-control"
																					value="" // Empty value initially
																					onChange={(e) => handleDateChange(i, 0, "endDate", e.target.value)}
																				/> */}
																				<div className="input-group">
																					<Flatpickr
																						value="" // Empty value initially
																						onChange={(selectedDates) =>
																							handleDateChange(i, 0, "endDate", selectedDates[0])
																						}
																						options={{
																							dateFormat: "Y-m-d", // Format of the date
																							minDate: "today", // Minimum date as today
																						}}
																						placeholder={t('profile.selectDate')} // Placeholder text
																						className="form-control" // Optional: Add a CSS class
																						// ref={(el) => (endflatpickrRef.current = el)} // Correctly set ref
																						ref={(el) => {
																							if (!endflatpickrRef.current[`end-${i}`]) {
																								endflatpickrRef.current[`end-${i}`] = el;
																							}
																						}}
																					/>
																					{/* Calendar Icon */}
																					<span className="input-group-text input-button" title="toggle"
																						// onClick={() => endflatpickrRef.current?.flatpickr?.open()}
																						onClick={() =>
																							endflatpickrRef.current[`end-${i}`]?.flatpickr?.open()
																						}
																						>
																						<i className="ri-calendar-line"></i>
																					</span>
																				</div>
																			</div>
																			<div className="col-lg-4 d-flex align-items-center mt-4">
																				<button
																					type="button"
																					className="btn btn-outline-danger me-2 d-flex align-items-center"
																					onClick={() => removeDateRow(i)}
																				>
																					<i className="ri-close-fill"></i> {t('common.remove')}
																				</button>
																				<button
																					type="button"
																					className="btn btn-outline-tmBlue"
																					onClick={() => addDateRow(i)}
																				>
																					<i className="ri-add-fill align-middle"></i> {t('common.addMore')}
																				</button>
																			</div>
																		</div>
																	)}
																	<div className="col-lg-3 col-md-2 d-flex align-items-center">
																		{/* Always show the Add button */}
																		{physicianInfo.length && physicianInfo.length - 1 === i &&
																			<button onClick={addPhysicianInfo(i)} type="button" className="btn btn-outline-tmBlue py-2 mx-2">
																				<i className="ri-add-fill align-middle"></i> {t('common.addPhysician')}
																			</button>}
																	</div>
																</div>
															)
														}
													})}

												</div>
											</div>
											<div className="col-lg-12 text-end">
												<button
													onClick={goToAddPhysician}
													type="button"
													className="btn btn-outline-success btnAdd me-2"
												>
													<i className="ri-user-add-line align-middle"></i> Add Physician
												</button>
											</div>
											{/*Prev-Next Button Section*/}
											< div className="row mt-3" >
												<div className="col-lg-12 text-end">
													<button onClick={() => setTab(1)} type="button" className="btn btn-secondary btnPrev me-2"><i className="ri-arrow-left-line align-middle"></i> {t('profile.prev')}</button>
													<button onClick={goNext(2)} type="button" className="btn btn-tmBlue btnNext"><i className="ri-arrow-right-line align-middle"></i> {t('profile.next')}</button>
												</div>
											</div>
										</form>
									</div>}

									{/*TAB-04*/}
									{tab === 3 && <div>
										<form>
											<div className="row">
												<div className="col-lg-12">
													{parentInfo && parentInfo.map((item, i) => (
														<div key={i} id={parentInfo.physician} className="form-group row">
															<div className="col-lg-5 col-md-6 mb-3">
																<label>{t('profile.parentName')} </label>
																{/* <select value={item.parent} name="parent" onChange={changeParentInfo(i)} className="form-select">
																	<option value="" disabled>-- Select Parent --</option>
																	{users && users.length !== 0 && users.parent && users.parent.map(item => (
																		<option key={item.account} value={item.account}>{item.first_name + ' ' + item.last_name}</option>
																	))}
																</select> */}
																<Select
																	value={
																		users && users.parent
																			? users.parent
																				.filter((parent) => parent.account === item.parent) // Find the selected parent
																				.map((parent) => ({
																					value: parent.account,
																					label: `${parent.first_name} ${parent.last_name}`, // Display parent name
																				}))[0] || null
																			: null
																	}
																	onChange={(selectedOption) =>
																		changeParentInfo(i)({
																			target: { name: 'parent', value: selectedOption?.value }, // Pass the selected parent's account
																		})
																	}
																	options={
																		users && users.parent
																			? users.parent.map((parent) => ({
																				value: parent.account,
																				label: `${parent.first_name} ${parent.last_name}`, // Parent name as label
																			}))
																			: []
																	}
																	placeholder={t('common.selectParent')}
																	classNamePrefix="react-select"
																/>
																{errorParent[i]?.parent && <span className="required">{errorParent[i].parent}</span>}
															</div>
															<div className="col-lg-5 col-md-4 mb-3">
																<label>{t('sidebar.physician')} </label>
																<Select
																	name="physician"
																	value={
																		users?.physician
																			.filter(option => option.account === item.physician)
																			.map(option => ({
																				value: option.account,
																				label: `${option.first_name} ${option.last_name}`,
																			}))[0] || null
																	}
																	onChange={(selectedOption) =>
																		changeParentInfo(i)({
																			target: { name: "physician", value: selectedOption?.value },
																		})
																	}
																	options={
																		users?.physician
																			.filter(item => physicianInfo.map(v => v.physician).includes(item.account))
																			.map(item => ({
																				value: item.account,
																				label: `${item.first_name} ${item.last_name}`,
																			}))
																	}
																	placeholder={t('common.selectPhysician')}
																	classNamePrefix="react-select"
																/>
																{errorParent[i]?.physician && <span className="required">{errorParent[i].physician}</span>}
															</div>
															<div className="col-lg-2 col-md-2 d-flex align-items-center">
																<label>&nbsp; </label>
																<button onClick={removeParentInfo(i)} type="button" className="btn btn-outline-danger py-2"><i className="ri-close-fill"></i></button>
																{parentInfo.length && parentInfo.length - 1 === i && <button onClick={addParentInfo(i)} type="button" className="btn btn-outline-tmBlue py-2 mx-2"><i className="ri-add-fill align-middle"></i></button>}
															</div>
															{errorParent[i]?.duplicate && <span className="required">{errorParent[i].duplicate}</span>}
														</div>))}

												</div>
											</div>
											{/*Prev-Next Button Section*/}
											<div className="row">
												<div className="col-lg-12 text-end">
													<button onClick={() => setTab(2)} type="button" className="btn btn-secondary btnPrev me-2"><i className="ri-arrow-left-line align-middle"></i> {t('profile.prev')}</button>
													<button onClick={handleSubmit} type="button" className="btn btn-tmBlue" ><i className="ri-check-double-fill align-middle"></i> {t('profile.submit')}</button>
												</div>
											</div>
										</form>
									</div>}
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* End Page Content Section */}

		</main>
	);

};


export default EditHospital;